<template>
  <div>
    <!-- SETA O STATUS DA TELA -->
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <!-- SETA OS DADOS DA TELA -->
    <div v-else class="app-his">
      <div class="app-fil-rel-nov" v-if="(cpntDialog === true && cpntMostrarFiltros === false)">
        <table>
          <tr :class="'n-col-' + appHisContarColunasLinha1">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Documento', chave: 'cnpj_cpf' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ]"
              :cpntNome="'Contatos'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.con"
              :cpntNenhum="false"

              :cpntRouter="'/contato/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, empresa: null, cnpj_cpf: null }"
              :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'con') }"
              ref="con"
              ></App-Filtro-Relatorio>
            </td>
            <td v-if="permissoes.vei === true && (filtros.dem === '' || filtros.dem.indexOf('dem_venda') !== -1)">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Placa', chave: 'placa' }, { nome: 'Marca', chave: 'id_mar_nome' }, { nome: 'Modelo', chave: 'id_mod_nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'demandaId_id_con_nome', ' (', 'id_mar_nome', ' ', 'id_mod_nome', ' ', 'placa', ')' ]"
              :cpntNome="'Veículo'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.vei"
              :cpntNenhum="true"

              :cpntRouter="'/veiculo/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, placa: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_mod: { j: { nome: null } }, id_mar: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } } }"
              :cpntWhere="{ aAnd: [ { f: 'status', m: 'veiculo', o: '=', v: '1' }, { aOr: [ { m: 'vei_mod', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_mar', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_modelo', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_marca', o: 's.ft', v: '#BUSCA#' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' }, { m: 'veiculo', o: 's.ft', v: '#BUSCA#' } ] } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'vei') }"
              ref="vei"
              ></App-Filtro-Relatorio>
            </td>
            <td v-if="permissoes.pet === true && (filtros.dem === '' || filtros.dem.indexOf('dem_venda') !== -1)">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' }, { nome: 'Raça', chave: 'id_pet_subespecie_nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' | ', 'id_pet_subespecie_nome', ' | ', 'demandaId_id_con_nome' ]"
              :cpntNome="'Pet'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pet"
              :cpntNenhum="true"

              :cpntRouter="'/pet/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' } } } }"
              :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'pet', o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'pet') }"
              ref="pet"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table>
          <tr :class="'n-col-' + ((permissoes.pro === true ? 1 : 0) + (permissoes.ser === true ? 1 : 0))">
            <td v-if="permissoes.pro === true">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Código', chave: 'codigo' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ]"
              :cpntNome="'Produto'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pro"
              :cpntNenhum="true"

              :cpntRouter="'/produto/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, codigo: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } }"
              :cpntWhere="() => { return appHisMontarWhereFiltro('pro') }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'pro') }"
              ref="pro"
              ></App-Filtro-Relatorio>
            </td>

            <td v-if="permissoes.ser === true">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Código', chave: 'id' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' - ', 'id_cat_nome', ' - ', 'id' ]"
              :cpntNome="'Serviço'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.ser"
              :cpntNenhum="true"

              :cpntRouter="'/servico/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, id_cat: { j: { nome: null } } }"
              :cpntWhere="() => { return appHisMontarWhereFiltro('ser') }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'ser') }"
              ref="ser"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>
      </div>

      <div class="app-fil-rel-nov" v-else>
        <table>
          <tr :class="'n-col-2'">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'select'"
              :cpntTabela="[ { nome: 'Nome', chave: 'demanda' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'demanda' ]"
              :cpntNome="'Demandas'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.dem"

              :cpntOnBuscarOptions="appHisBuscarDemandas"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'dem') }"
              ref="dem"
              ></App-Filtro-Relatorio>
            </td>

            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'select'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome' ]"
              :cpntNome="'Status'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.dem_sta"

              :cpntOnBuscarOptions="appHisBuscarDemandaStatus"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'dem_sta') }"
              ref="dem_sta"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table>
          <tr :class="'n-col-' + appHisContarColunasLinha1">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Documento', chave: 'cnpj_cpf' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ]"
              :cpntNome="'Contatos'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.con"
              :cpntNenhum="false"

              :cpntRouter="'/contato/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, empresa: null, cnpj_cpf: null }"
              :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'con') }"
              ref="con"
              ></App-Filtro-Relatorio>
            </td>

            <td v-if="permissoes.vei === true && (filtros.dem === '' || filtros.dem.indexOf('dem_venda') !== -1)">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Placa', chave: 'placa' }, { nome: 'Marca', chave: 'id_mar_nome' }, { nome: 'Modelo', chave: 'id_mod_nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'demandaId_id_con_nome', ' (', 'id_mar_nome', ' ', 'id_mod_nome', ' ', 'placa', ')' ]"
              :cpntNome="'Veículo'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.vei"
              :cpntNenhum="true"

              :cpntRouter="'/veiculo/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, placa: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_mod: { j: { nome: null } }, id_mar: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } } }"
              :cpntWhere="{ aAnd: [ { f: 'status', m: 'veiculo', o: '=', v: '1' }, { aOr: [ { m: 'vei_mod', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_mar', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_modelo', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_marca', o: 's.ft', v: '#BUSCA#' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' }, { m: 'veiculo', o: 's.ft', v: '#BUSCA#' } ] } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'vei') }"
              ref="vei"
              ></App-Filtro-Relatorio>
            </td>

            <td v-if="permissoes.pet === true && (filtros.dem === '' || filtros.dem.indexOf('dem_venda') !== -1)">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' }, { nome: 'Raça', chave: 'id_pet_subespecie_nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' | ', 'id_pet_subespecie_nome', ' | ', 'demandaId_id_con_nome' ]"
              :cpntNome="'Pet'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pet"
              :cpntNenhum="true"

              :cpntRouter="'/pet/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' } } } }"
              :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'pet', o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'pet') }"
              ref="pet"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table v-if="permissoes.pro === true">
          <tr :class="'n-col-3'">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Categoria Produto'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.pro_cat"
              :cpntNenhum="false"

              :cpntRouter="'/produto/categoria/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'pro_cat') }"
              ref="pro_cat"
              ></App-Filtro-Relatorio>
            </td>

            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Marca Produto'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.pro_mar"
              :cpntNenhum="false"

              :cpntRouter="'/produto/marca/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'pro_mar') }"
              ref="pro_mar"
              ></App-Filtro-Relatorio>
            </td>

            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Código', chave: 'codigo' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ]"
              :cpntNome="'Produto'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pro"
              :cpntNenhum="true"

              :cpntRouter="'/produto/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, codigo: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } }"
              :cpntWhere="() => { return appHisMontarWhereFiltro('pro') }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'pro') }"
              ref="pro"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table v-if="permissoes.ser === true && (filtros.dem === '' || filtros.dem.indexOf('dem_venda') !== -1)">
          <tr :class="'n-col-2'">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Categoria Serviço'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.ser_cat"
              :cpntNenhum="false"

              :cpntRouter="'/servico/categoria/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'ser_cat') }"
              ref="ser_cat"
              ></App-Filtro-Relatorio>
            </td>

            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Código', chave: 'id' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' - ', 'id_cat_nome', ' - ', 'id' ]"
              :cpntNome="'Serviço'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.ser"
              :cpntNenhum="true"

              :cpntRouter="'/servico/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, id_cat: { j: { nome: null } } }"
              :cpntWhere="() => { return appHisMontarWhereFiltro('ser') }"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'ser') }"
              ref="ser"
              ></App-Filtro-Relatorio>
            </td>           
          </tr>
        </table>

        <table>
          <tr :class="'n-col-1'">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'seletor-data'"
              :cpntNome="''"
              :cpntTodos="'Todas as datas'"
              :cpntValue="filtros.dat"
              @UPDATE_VALUE_FILTRO="(value) => { appHisAtualizarFiltro(value, 'dat') }"
              ref="dat"
              ></App-Filtro-Relatorio>
            </td>     
          </tr>
        </table>
      </div>
      
      <div class="app-his-botao">
        <!-- SETA O BOTÃO PESQUISAR -->
        <App-Button :cpntStatus="pesquisa === 'carregando' ? pesquisa: ''" :cpntClass="'btn btn-primary'" @onClick="() => { appHisPesquisar() }">Pesquisar</App-Button>

        <!-- SETA O BOTÃO MINHA PERSONALIZAÇÃO -->
        <App-Minha-Personalizacao v-if="[ '', null, undefined ].indexOf(mper.tabper) === -1"
        :cpntMper='mper.tabper'
        :cpntMperRpp='mper.rpp'
        :cpntMperOrder='mper.order'
        :cpntMperOrderOptions='mper.orderOptions'
        :cpntMperField='mper.field'
        :cpntMperFieldOptions='mper.fieldOptions'
        :cpntMperFiltro='mper.filtro'

        @UPDATE='() => { appHisPesquisar() }'
        ></App-Minha-Personalizacao>

        <App-Button v-if="cpntDialog === true" :cpntClass="'btn btn-default btn-sm'" @onClick="mostrarGrafico = !mostrarGrafico">{{ mostrarGrafico !== true ? 'Mostrar Gráfico' : 'Ocultar Gráfico' }}</App-Button>
      </div>

      <div class="app-his-resultado2" :class="('app-his-res--' + $route.name) + ' ' + ('dem-qtde--' + Object.keys(pesquisa).length)" v-if="pesquisa !== null && pesquisa !== 'carregando'">
        <div v-if="grafico !== null" class="app-his-tp_grafico" v-show="(mostrarGrafico === true || (cpntDialog !== true && mostrarGrafico === ''))">
          <!-- SETA O SELETOR DO CAMPO -->
          <div>
            <App-Toggles :data-time="time" 
            :cpntStatus='campos.tp_grafico.status'
            :cpntId='campos.tp_grafico.id'
            :cpntClassDivField='campos.tp_grafico.classDivField'
            :cpntNome='campos.tp_grafico.nome'
            :cpntValue='campos.tp_grafico.value'
            :cpntDisabled='campos.tp_grafico.disabled'
            :cpntMostrar='campos.tp_grafico.mostrar'
            :cpntMensagem='campos.tp_grafico.mensagem'
            :cpntMensagemTipo='campos.tp_grafico.mensagemTipo'
            :cpntOn='campos.tp_grafico.on'
            :cpntOff='campos.tp_grafico.off'
            :cpntExplica='campos.tp_grafico.explica'
            :cpntWidth='campos.tp_grafico.width'
            :cpntTabIndex='campos.tp_grafico.tabIndex'
  
            :cpntOnChange='campos.tp_grafico.onChange'
            :cpntOnBlur='campos.tp_grafico.onBlur'
            ref='tp_grafico'
            ></App-Toggles>
          </div>
          
          <!-- SETA O ESPAÇO DO CAMPO -->
          <canvas ref="grafico" width="1000" height="300" style="position: relative; z-index: 1;"></canvas>
        </div>

        <div>
          <RF-Aba v-if="typeof pesquisa === 'object'"
          :cpntAbas="Object.values(pesquisa)"
          :cpntValue="abaVal"
          :cpntOnChange="appHisOnChangeAba">
          <template v-slot:titulo="{ cpntAba, indexA }">
            <!-- SETA O NOME DA ABA -->
            <span v-html="cpntAba.nome"></span>

            <!-- SETA O VALOR TOTAL ENCONTRADO -->
            <!-- <span style="font-size: calc(100% - 2px);" v-html="' (' + cpntAba.totais._qtde_sum + ')'"></span> -->

            <RF-Explica :cpntTitle='("<span>Quantidade Total: </span><b>" + pesquisa[indexA].totais._qtde_sum + "</b>") + ([ "fabricacao", "insumo" ].indexOf(indexA) !== -1 ? "" : "<br/><br/><span>Valor Total: </span><b>R$ " + pesquisa[indexA].totais._total + "</b>")'></RF-Explica>
          </template>

          <template slot='conteudo'>
            <div class="app-his-resultado">
              <table v-if="[ '', null, undefined ].indexOf(pesquisa) === -1 && [ '', null, undefined ].indexOf(pesquisa[abaVal]) === -1">
                <tr v-if="pesquisa[abaVal].disabled !== true">
                  <td :key="'dem--' + abaVal" :class="appHisMontarClassDemanda(abaVal)">
                    <div>
                      <div class="titulo">
                        <span v-if="abaVal === 'dem_venda'">Venda</span>
                        <span v-else-if="abaVal === 'dem_compra'">Compra</span>
                        <span v-else-if="abaVal === 'dem_dev_cliente'">Devolução Cliente</span>
                        <span v-else-if="abaVal === 'dem_dev_fornecedor'">Devolução Fornecedor</span>
                        <span v-else-if="abaVal === 'fabricacao'">Fabricação - Produto Acabado</span>
                        <span v-else-if="abaVal === 'insumo'">Fabricação - Insumo</span>
                      </div>
                      
                      <div class="sub-titulo" v-if="[ '', null, undefined ].indexOf(pesquisa[abaVal].totais) === -1">
                        <div>
                          <span>Quantidade Total: </span><b>{{ pesquisa[abaVal].totais._qtde_sum }}</b>
                        </div>
                        <template v-if="pesquisa[abaVal].totais.detalhes === true && permissoes.pro === true && abaVal !== 'insumo' && abaVal !== 'fabricacao'">
                          <div>
                            <span>Valor Subtotal: </span><b>R$ {{ pesquisa[abaVal].totais._valor_tot_sum }}</b>
                          </div>
                          <div>
                            <span>Valor Frete: </span><b>R$ {{ pesquisa[abaVal].totais._valor_fre_sum }}</b>
                          </div>
                          <div>
                            <span>Valor Seguro: </span><b>R$ {{ pesquisa[abaVal].totais._valor_seg_sum }}</b>
                          </div>
                          <div>
                            <span>Valor Desconto: </span><b>R$ {{ pesquisa[abaVal].totais._valor_des_sum }}</b>
                          </div>
                          <div>
                            <span>Valor ODA: </span><b>R$ {{ pesquisa[abaVal].totais._valor_oda_sum }}</b>
                          </div>
                          <div>
                            <span>Valor ICMS ST: </span><b>R$ {{ pesquisa[abaVal].totais._p_icms_st_v_sum }}</b>
                          </div>
                          <div>
                            <span>Valor FCP ST: </span><b>R$ {{ pesquisa[abaVal].totais._p_icms_fcp_st_v_sum }}</b>
                          </div>
                          <div>
                            <span>Valor IPI: </span><b>R$ {{ pesquisa[abaVal].totais._p_ipi_v_sum }}</b>
                          </div>
                        </template>
                        <div v-if="abaVal !== 'insumo' && abaVal !== 'fabricacao'">
                          <span>Valor Total: </span><b>R$ {{ pesquisa[abaVal].totais._total }}</b>
                          <template v-if="permissoes.pro === true">
                            <App-Button :cpntIcone='pesquisa[abaVal].totais.detalhes === false ? "mais" : "menos"' @onClick='() => { pesquisa[abaVal].totais.detalhes = !pesquisa[abaVal].totais.detalhes }'></App-Button>
                          </template>
                        </div>
                      </div>
  
                      <!-- MOSTRA TODAS AS DEMANDAS MENOS A VENDA -->
                      <App-Historico-Tabela v-if="abaVal !== 'dem_venda'"
                      :cpntDemanda="abaVal"
                      :cpntLinhas="pesquisa[abaVal].linhas"
                      :cpntColunas="appHisMontarColunas"
                      :cpntTotais="pesquisa[abaVal].totais"
                      :cpntTotal="pesquisa[abaVal].countAll"
                      :cpntMontarRouter="appHisMontarRouter"
                      :cpntMontarMethod="appHisMontarMethod"
                      :cpntMontarField="appHisMontarField"
                      :cpntMontarWhere="appHisMontarWhere"
                      :cpntMontarOrder="appHisMontarOrder"
                      :cpntFiltros="filtros"
                      :cpntRpp="Number(tabper.rpp)"
  
                      @UPDATE_TOTAIS="(value) => { appHisSetarTotais(value) }"
                      ></App-Historico-Tabela>
  
                      <!-- MOSTRA A DEMANDA DE VENDA EM TABELA SEPARADA PARA PRODUTO E SERVIÇO -->
                      <template v-else>
                        <App-Historico-Tabela v-if="filtros.pro !== '__NENHUM__' && permissoes.pro === true && (filtros.dem === '' || filtros.dem.indexOf('dem_venda') !== -1)"
                        :cpntDemanda="abaVal + '__produto'"
                        :cpntLinhas="pesquisa[abaVal].produto.linhas"
                        :cpntColunas="appHisMontarColunas"
                        :cpntTotais="pesquisa[abaVal].produto.totais"
                        :cpntTotal="pesquisa[abaVal].produto.countAll"
                        :cpntMontarRouter="appHisMontarRouter"
                        :cpntMontarMethod="appHisMontarMethod"
                        :cpntMontarField="appHisMontarField"
                        :cpntMontarWhere="appHisMontarWhere"
                        :cpntMontarOrder="appHisMontarOrder"
                        :cpntFiltros="filtros"
                        :cpntRpp="Number(tabper.rpp)"
  
                        @UPDATE_TOTAIS="(value) => { appHisSetarTotais(value) }"
                        ></App-Historico-Tabela>
  
                        <App-Historico-Tabela v-if="filtros.ser !== '__NENHUM__' && permissoes.ser === true && (filtros.dem === '' || filtros.dem.indexOf('dem_venda') !== -1)"
                        :cpntDemanda="abaVal + '__servico'"
                        :cpntLinhas="pesquisa[abaVal].servico.linhas"
                        :cpntColunas="appHisMontarColunas"
                        :cpntTotais="pesquisa[abaVal].servico.totais"
                        :cpntTotal="pesquisa[abaVal].servico.countAll"
                        :cpntMontarRouter="appHisMontarRouter"
                        :cpntMontarMethod="appHisMontarMethod"
                        :cpntMontarField="appHisMontarField"
                        :cpntMontarWhere="appHisMontarWhere"
                        :cpntMontarOrder="appHisMontarOrder"
                        :cpntFiltros="filtros"
                        :cpntRpp="Number(tabper.rpp)"
  
                        @UPDATE_TOTAIS="(value) => { appHisSetarTotais(value) }"
                        ></App-Historico-Tabela>
                      </template>
                    </div>
                  </td>
                </tr>

                <tr v-else>
                  <td>
                    <div style="padding: 20px 0px; text-align: center;">
                      Nenhum registro encontrado
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </template>
          </RF-Aba>
        </div>       
      </div>
    </div>
  </div>
</template>

<style scoped>
.app-his-botao {
  margin-top: 10px;
  text-align: center;
}

.app-his-resultado2 {
  margin-top: 10px;
}
  .app-his-resultado2 > .app-his-tp_grafico > button {
    margin-left: 10px;
    margin-bottom: 10px;
    vertical-align: bottom;
  }
  .app-his-resultado2 > .app-his-tp_grafico > div {
    width: 170px;
    /* margin: 0px auto; */
    margin-top: 30px;
    margin-bottom: 10px;
    padding-left: 10px;
    display: inline-block;
    vertical-align: bottom;
  }
    .app-his-resultado2 > .app-his-tp_grafico > div > div {
      width: 170px;
      margin: 0px auto;
    }
  .app-his-resultado > table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 10px 0px;
  }
    .app-his-resultado > table > tr > td {
      padding: 5px;
      vertical-align: top;
      border: 1px solid #ccc;
      border-radius: 5px;
    }

    /* .app-his-resultado:not(.app-his-res--servico_historico):not(.dem-qtde--1) > table > tr > td > div {
      min-width: 500px;
      max-width: 800px;
    } */
    /* .app-his-resultado > table > tr.dem-qtde--1 > td {
      width: 100%;
      max-width: 100%;
    }
    .app-his-resultado > table > tr.dem-qtde--2 > td {
      width: calc(100% / 2);
      max-width: calc(100% / 2);
    }
    .app-his-resultado > table > tr.dem-qtde--3 > td {
      width: calc(100% / 3);
      max-width: calc(100% / 3);
    }
    .app-his-resultado > table > tr.dem-qtde--4 > td {
      width: calc(100% / 4);
      max-width: calc(100% / 4);
    } */
      .app-his-resultado > table > tr > td > div {
        margin: 5px;
        height: 100%;
        position: relative;
        min-height: 500px;
      }
        .app-his-resultado > table > tr > td > div > div.app-his-tab {
          margin-top: 10px;
        }
        .app-his-resultado > table > tr > td > div > div.titulo {
          font-weight: bold;
          text-align: center;
          font-size: calc(100% + 2px);
        }
        .app-his-resultado > table > tr > td > div > div.sub-titulo > div {
          margin-bottom: 5px;
        }
          .app-his-resultado > table > tr > td > div > div.sub-titulo > div > span {
            font-size: calc(100% + 1px);
          }
          .app-his-resultado > table > tr > td > div > div.sub-titulo > div > b {
            font-size: calc(100% + 2px);
          }
          .app-his-resultado > table > tr > td > div > div.sub-titulo > div > button {
            padding: 2px 4px !important;
            margin-left: 5px;
            vertical-align: 2px;
          }
</style>

<style>
.app-his > .app-his-botao > .cpnt-mper > button {
  margin: 0px 8px !important;
  height: 30px !important;
  width: 30px !important;
  padding: 0px !important;
  text-align: center !important;
}
.app-his-resultado > .app-his-tp_grafico > div > div > div {
  width: 100% !important;
}
.app-his-resultado > table > tr > td > div > div.sub-titulo > div > button > span > img {
  width: 15px;
  height: 15px;
}
</style>

<script>
  var moment = require('moment')

  export default {
    props: {
      cpntFiltros: {
        required: false,
        type: Object
      },
      cpntDialog: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntMostrarFiltros: {
        required: false,
        type: Boolean,
        default: function () {
          return true
        }
      }
    },
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba-2.vue'),
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      
      'App-Minha-Personalizacao': () => import('@/components/_geral/Minha-Personalizacao.vue'),
      'App-Filtro-Relatorio': () => import('@/components/_geral/Filtro-Relatorio.vue'),
      'App-Historico-Tabela': () => import('@/components/historico/Historico-Tabela.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        abaVal: '',
        pesquisa: null,
        grafico: null,
        mostrarGrafico: '',
        tabper: {},
        mper: {
          tabper: '',
          rpp: true,
          order: true,
          orderOptions: [],
          field: true,
          fieldOptions: [],
          filtro: false,
        },
        permissoes: {
          vei: false,
          pet: false,
          pro: false,
          ser: false
        },
        filtros: {
          dem: '',
          dem_sta: '',
          con: '',
          pet: '',
          vei: '',
          pro: '',
          pro_cat: '',
          pro_mar: '',
          ser: '',
          ser_cat: '',
          dat: ''
        },
        params: {
          qtdeMes: null,
          dataIni: '',
          dataFim: '',
          tipo: ''
        },
        campos: {
          tp_grafico: {
            status: '',
            nome: 'Apresentar Gráfico por:',
            on: 'Valor R$',
            off: 'Quantidade',
            value: true,
            onChange: this.appHisAlterarGrafico
          }
        }
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.appHisSetarStatusGeral('carregando')

      // FAZ A VERIFICAÇÃO DAS PERMISSÕES DO USUARIO
      this.appHisVerificarPermissao()

      // CHAMA A FUNÇÃO PARA INICIAR O CARREGAMENTO
      this.appHisIniciar()
    },
    methods: {
      appHisBuscarValorMper: function () {
        return new Promise((success) => {
          if ([ '', null, undefined ].indexOf(this.mper.tabper) !== -1 || [ '', null, undefined ].indexOf(this.$store.state.mPer[this.mper.tabper]) === -1) {
            success()
          } else {
            this.$store.state.comunicaAPI('/config/mper/get/', 'GET', this.mper.tabper, (retorno) => {
              // INICIA O VETOR DE PERSONALIZAÇÃO
              var vetor = { field: '', rpp: '10', order: '0', flag: false, filtro: '' }
    
              // VERIFICA SE EXISTE O FILTRO
              retorno.data.filtro = ''
              if ([ '', null, undefined ].indexOf(retorno.data.id_cg_filtro_j_filtro) === -1) {
                // CONVERTE O VALOR RECEBIDO
                retorno.data.id_cg_filtro_j_filtro.j_filtro = JSON.parse(retorno.data.id_cg_filtro_j_filtro.j_filtro)
    
                // PEGA O VALOR CONVERTIDO
                retorno.data.filtro = JSON.parse(JSON.stringify(retorno.data.id_cg_filtro_j_filtro))
    
                // DELETA O VALOR NÃO UTILIZADO MAIS
                delete retorno.data.id_cg_filtro_j_filtro
              }
    
              // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
              var flag = Object.values(retorno.data).filter(item => [ '', null, undefined ].indexOf(item) === -1).length >= 1
    
              // VERIFICA SE FOI ENCONTRADO ALGUMA PERSONALIZAÇÃO
              if (flag === true) {
                vetor = retorno.data
                vetor.flag = true
              }
    
              // SALVA A MINHA PERSONALIZAÇÃO RECEBIDA DA API
              this.$store.commit('SET_MINHA_PERSONALIZACAO', { id: this.mper.tabper, dados: vetor })
        
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              success()
            }, this.appHisSetarStatusGeral)
          }
        })
      },
      appHisSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appHisVerificarPermissao: function () {
        // VERIFICA SE TEM PERMISSÃO VEICULO
        this.permissoes.vei = [].indexOf(this.$route.name) === -1 && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO PET
        this.permissoes.pet = [].indexOf(this.$route.name) === -1 && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO PRODUTO
        this.permissoes.pro = (this.cpntDialog === true || [ 'historico', 'produto_historico', 'produto_historico_busca' ].indexOf(this.$route.name) !== -1) && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO SERVIÇO
        this.permissoes.ser = (this.cpntDialog === true || [ 'historico', 'servico_historico', 'servico_historico_busca' ].indexOf(this.$route.name) !== -1) && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, null, null, false) === true
      },
      appHisMontarWhereFiltro: function (campo) {
        // INICIA A VARIAVEL WHERE
        var where = {} 
        
        // SETA O VALOR DE CADA CAMPO
        switch (campo) {
          case 'pro':
            // SETA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

            // VERIFICA SE TEM QUE FILTRAR CATEGORIA
            if (this.filtros.pro_cat !== '') {
              where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.pro_cat.join() })
            }

            // VERIFICA SE TEM QUE FILTRAR MARCA
            if (this.filtros.pro_mar !== '') {
              where.aAnd.push({ f: 'id_mar', o: '=', v: this.filtros.pro_mar.join() })
            }
            break

          case 'ser':
            // SETA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

            // VERIFICA SE TEM QUE FILTRAR CATEGORIA
            if (this.filtros.ser_cat !== '') {
              where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.ser_cat.join() })
            }
            break
        }

        // RETORNA O VALOR MONTADO
        return where
      },
      appHisAtualizarFiltro: function (value, chave) {
        // SETA O NOVO VALOR DO FILTRO
        this.filtros[chave] = value

        // VERIFICA A AÇÃO PERSONALIZADA QUE DEVE REALIZAR
        switch (chave) {
          case 'dem':
            if ([ '', null, undefined ].indexOf(this.$refs.dem) === -1) {
              // LIMPA OS OPTIONS DO CAMPO
              this.$refs.dem.options = null
    
              // LIMPA OS OPTIONS DO CAMPO
              this.$refs.time = new Date().getTime()
            }
            break

          case 'pro_cat':
          case 'pro_mar':
            this.filtros.pro = ''
            break

          case 'ser_cat':
            this.filtros.ser = ''
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appHisBuscarDemandas: function (callback) {
        // INICIA A VARIAVEL DE OPÇÕES
        var options = []

        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 12 ], null, [ 19 ], null, null, null, false) === true) {
          // VERIFICA SE NA TELA TERÁ ACESSO A DEMANDA INFORMADA
          if ([ 'servico_historico', 'servico_historico_busca' ].indexOf(this.$route.name) === -1) {
            options.push({ id: 'fabricacao',  demanda: 'Fabricação - Produto Acabado' })
          }
  
          // VERIFICA SE NA TELA TERÁ ACESSO A DEMANDA INFORMADA
          if ([ 'servico_historico', 'servico_historico_busca' ].indexOf(this.$route.name) === -1) {
            options.push({ id: 'insumo',  demanda: 'Fabricação - Insumo' })
          }
        }

        // VERIFICA SE NA TELA TERÁ ACESSO A DEMANDA INFORMADA
        if ([ 'servico_historico', 'servico_historico_busca' ].indexOf(this.$route.name) === -1) {
          options.push({ id: 'dem_compra',  demanda: 'Compra' })
        }
        
        // VERIFICA SE NA TELA TERÁ ACESSO A DEMANDA INFORMADA
        if ([ 'servico_historico', 'servico_historico_busca' ].indexOf(this.$route.name) === -1) {
          options.push({ id: 'dem_dev_fornecedor', demanda: 'Devolução Fornecedor' })
        }

        // VERIFICA SE NA TELA TERÁ ACESSO A DEMANDA INFORMADA
        if ([ ].indexOf(this.$route.name) === -1) {
          options.push({ id: 'dem_venda', demanda: 'Venda' })
        }

        // VERIFICA SE NA TELA TERÁ ACESSO A DEMANDA INFORMADA
        if ([ 'servico_historico', 'servico_historico_busca' ].indexOf(this.$route.name) === -1) {
          options.push({ id: 'dem_dev_cliente', demanda: 'Devolução Cliente' })
        }

        // VERIFICA SE EXISTE O COMPONENT FILHO
        if ([ '', null, undefined ].indexOf(this.$refs.dem) === -1) {
          // LIMPA OS OPTIONS DO CAMPO
          this.$refs.dem.options = null
  
          // LIMPA OS OPTIONS DO CAMPO
          this.$refs.time = new Date().getTime()
        }

        // RETORNA O VALOR MONTADO
        callback(options)
      },
      appHisBuscarDemandaStatus: function (callback) {
        // INICIA A VARIAVEL OPTIONS
        var options = []

        // INICIA AS DEMANDAS QUE SERÁ TRATADA
        var demanda = this.filtros.dem !== '' ? this.filtros.dem : [ 'insumo', 'fabricacao', 'dem_compra', 'dem_dev_fornecedor', 'dem_venda', 'dem_dev_cliente' ]

        // MONTA OS OPTIONS 
        for (var index in demanda) {
          if (demanda[index] === 'dem_venda') {
            options = options.concat([
              { id: 'dem_venda__1', nome: 'Orçamento de Venda' },
              { id: 'dem_venda__2', nome: 'Venda' }
            ])
          } else if (demanda[index] === 'dem_compra') {
            options = options.concat([
              { id: 'dem_compra__1', nome: 'Orçamento de Compra' },
              { id: 'dem_compra__2', nome: 'Compra' }
            ])
          } else if (demanda[index] === 'dem_dev_fornecedor') {
            options = options.concat([ { id: 'dem_dev_fornecedor', nome: 'Devolução Fornecedor' } ])
          } else if (demanda[index] === 'dem_dev_cliente') {
            options = options.concat([ { id: 'dem_dev_cliente', nome: 'Devolução Cliente' } ])
          } else if (demanda[index] === 'insumo') {
            options = options.concat([ { id: 'insumo', nome: 'Fabricação - Insumo' } ])
          } else if (demanda[index] === 'fabricacao') {
            options = options.concat([ { id: 'fabricacao', nome: 'Fabricação - Produto Acabado' } ])
          }
        }

        // RETORNA O VALOR MONTADO
        callback(options)
      },
      appHisIniciar: function () {
        // LIMPA AS VARIAVEIS
        this.mper.tabper = ''
        this.mper.rpp = true
        this.mper.order = true
        this.mper.orderOptions = [
          { id: '0', nome: 'Código Demanda Decrescente'  },
          { id: '1', nome: 'Código Demanda Crescente'    },
          { id: '2', nome: 'Ordem Alfabética Produto'    },
          { id: '3', nome: 'Ordem Alfabética Contato'    },
          { id: '4', nome: 'Código Item Decrescente'     },
          { id: '5', nome: 'Código Item Crescente'       },
          { id: '6', nome: 'Data Demanda Decrescente'    },
          { id: '7', nome: 'Data Demanda Crescente'      }
        ]
        this.mper.field = true
        this.mper.fieldOptions = [
          { mPer: 1,  chave: 'demandaId',               nome: 'Demanda Cód.'          },
          { mPer: 1,  chave: 'demandaId_id_con_nome',   nome: 'Contato'               },
          { mPer: 1,  chave: 'demandaId_data',          nome: 'Demanda Data'          },
          { mPer: 1,  chave: 'item_codigo',             nome: 'Cód.'                  },
          { mPer: 1,  chave: 'item_nome',               nome: 'Nome'                  },
          { mPer: 1,  chave: '_qtde',                   nome: 'Qtde.'                 },
          { mPer: 1,  chave: '_valor_uni',              nome: 'Valor Unitário'        },
          { mPer: 0,  chave: '_valor_tot',              nome: 'Subtotal'              },
          { mPer: 0,  chave: '_valor_fre',              nome: 'Valor Frete'           },
          { mPer: 0,  chave: '_valor_seg',              nome: 'Valor Seguro'          },
          { mPer: 0,  chave: '_valor_des',              nome: 'Valor Desconto'        },
          { mPer: 0,  chave: '_valor_oda',              nome: 'Valor ODA'             },
          { mPer: 0,  chave: '_p_ipi_v',                nome: 'Valor IPI'             },
          { mPer: 0,  chave: '_p_icms_st_v',            nome: 'Valor ICMS ST'         },
          { mPer: 0,  chave: '_p_icms_fcp_st_v',        nome: 'Valor ICMS FCP ST'     },
          { mPer: 1,  chave: '_total',                  nome: 'Total', explica: { mensagem: 'Total  = ((Qtde * Valor Unitário) + Valor Frete + Valor Seguro + Valor Desconto + Valor ODA + Valor IPI + Valor ICMS ST + Valor ICMS FCP ST)', posicaoMy: 'top right', posicaoAt: 'bottom left' } }
        ]

        // VERIFICA QUAL É A PERSONALIZAÇÃO QUE DEVE REALIZAR
        switch (this.$route.name) {
          case 'produto_historico':
            this.mper.tabper = 'ProdutoHistorico'
            break

          case 'servico_historico':
            this.mper.tabper = 'ServicoHistorico'
            break

          default:
            this.mper.tabper = 'DemandaItemHistorico'
            break
        }

        // SETA OS VALORES RECEBIDOS
        if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1) {
          for (var index in this.cpntFiltros) {
            if ([ undefined ].indexOf(this.filtros[index]) === -1) {
              this.appHisAtualizarFiltro(this.cpntFiltros[index], index)
            }
          }
        }

        // CARREGA A MINHA PERSONALIZAÇÃO
        this.appHisBuscarValorMper().then(() => {
          // SETA O STATUS DA PAGINA
          this.appHisSetarStatusGeral('')

          // VERIFICA SE DEVE REALIZAR O PESQUISAR OU NÃO
            if ([ 'produto_historico_busca', 'servico_historico_busca' ].indexOf(this.$route.name) !== -1) {
              this.appHisPesquisar()
            } else if (this.cpntDialog === true) {
            this.appHisPesquisar()
          }
        })
      },
      appHisMontarOrder: function (demanda) {
        // INICIA A VARIAVEL
        var order = {}

        // FAZ AS VERIFICAÇÕES
        if (demanda == 'insumo' || demanda == 'fabricacao') {
          order = { id: 'desc' }
        } else {
          switch (this.tabper.order) {
            case '0':
              order = { demandaId: 'desc', id: 'desc' }
              break
  
            case '1':
              order = { demandaId: 'asc', id: 'desc' }
              break
  
            case '2':
              order = { item_nome: 'asc', id: 'desc' }
              break
  
            case '3':
              order = { demandaId_id_con_nome: 'asc', id: 'desc' }
              break
  
            case '4':
              order = { item_codigo: 'asc', id: 'desc' }
              break
  
            case '5':
              order = { item_codigo: 'desc', id: 'desc' }
              break
  
            case '6':
              order = { demandaId_data: 'asc', id: 'desc' }
              break
  
            case '7':
              order = { demandaId_data: 'desc', id: 'desc' }
              break
          }
        }

        // RETORNA A ROTA MONTADA
        return order
      },
      appHisMontarRouter: function (demanda) {
        // INICIA A VARIAVEL
        var rota = {}

        // FAZ AS VERIFICAÇÕES
        switch (demanda) {
          case 'fabricacao':
          case 'fabricacao_qtde':
          case 'fabricacao_grafico':
          case 'fabricacao_data_ini_fim':
            rota = '/produto/fabricado/get'
            break

          case 'insumo':
          case 'insumo_qtde':
          case 'insumo_grafico':
          case 'insumo_data_ini_fim':
            rota = '/insumo/consumo/get'
            break

          case 'dem_venda__produto':
          case 'dem_venda__produto_qtde':
          case 'dem_venda__produto_grafico':
          case 'dem_venda__produto_data_ini_fim':
            rota = '/venda/produto/get'
            break

          case 'dem_venda__servico':
          case 'dem_venda__servico_qtde':
          case 'dem_venda__servico_grafico':
          case 'dem_venda__servico_data_ini_fim':
            rota = '/venda/servico/get'
            break

          case 'dem_compra':
          case 'dem_compra_qtde':
          case 'dem_compra_grafico':
          case 'dem_compra_data_ini_fim':
            rota = '/demanda/dem-compra/dem-produto/get'
            break

          case 'dem_dev_fornecedor':
          case 'dem_dev_fornecedor_qtde':
          case 'dem_dev_fornecedor_grafico':
          case 'dem_dev_fornecedor_data_ini_fim':
            rota = '/demanda/dem-dev-fornecedor/dem-produto/get'
            break

          case 'dem_dev_cliente':
          case 'dem_dev_cliente_qtde':
          case 'dem_dev_cliente_grafico':
          case 'dem_dev_cliente_data_ini_fim':
            rota = '/demanda/dem-dev-cliente/dem-produto/get'
            break
        }

        // RETORNA A ROTA MONTADA
        return rota
      },
      appHisMontarMethod: function (demanda) {
        // INICIA A VARIAVEL
        var metodo = {}

        // FAZ AS VERIFICAÇÕES
        switch (demanda) {
          case 'fabricacao':
          case 'fabricacao_qtde':
          case 'fabricacao_grafico':
          case 'fabricacao_data_ini_fim':
          case 'insumo':
          case 'insumo_qtde':
          case 'insumo_grafico':
          case 'insumo_data_ini_fim':
          case 'dem_venda__produto':
          case 'dem_venda__produto_qtde':
          case 'dem_venda__produto_grafico':
          case 'dem_venda__produto_data_ini_fim':
          case 'dem_venda__servico':
          case 'dem_venda__servico_qtde':
          case 'dem_venda__servico_grafico':
          case 'dem_venda__servico_data_ini_fim':
          case 'dem_compra':
          case 'dem_compra_qtde':
          case 'dem_compra_grafico':
          case 'dem_compra_data_ini_fim':
          case 'dem_dev_fornecedor':
          case 'dem_dev_fornecedor_qtde':
          case 'dem_dev_fornecedor_grafico':
          case 'dem_dev_fornecedor_data_ini_fim':
          case 'dem_dev_cliente':
          case 'dem_dev_cliente_qtde':
          case 'dem_dev_cliente_grafico':
          case 'dem_dev_cliente_data_ini_fim':
            metodo = 'POST'
            break
        }

        // RETORNA O VALOR MONTADO
        return metodo
      },
      appHisMontarField: function (demanda) {
        // INICIA A VARIAVEL
        var field = {}

        // VERIFICA A DEMANDA QUE ESTÁ SENDO TRATADA
        switch (demanda) {
          case 'dem_venda__produto':
            field = {
              id: null,
              cod_venda: { a: 'demandaId', j: { vencimento: { a: 'demandaId_data' }, status: { a: 'demandaId_status' }, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } } } },
              id_pro: { a: 'item', j: { codigo: { a: 'item_codigo' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } },
              qtde: null,
              valor_uni_novo: { a: 'valor_uni' },
              valor_tot_novo: { a: 'valor_tot' },
              valor_fre: null,
              valor_seg: null,
              valor_des_novo: { a: 'valor_des' },
              valor_oda: null,
              p_ipi_v: null,
              p_icms_st_v: null,
              p_icms_fcp_st_v: null
            }
            break
          case 'dem_venda__produto_qtde':
            field = {
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              cod_venda: { o: 'countDistinct', a: 'qtde_demanda', j: { vencimento: { a: '_REMOVER_' } } },
              id: { o: 'count', a: 'qtde_itens' },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'dem_venda__produto_grafico':
            field = {
              cod_venda: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'day', 'month', 'year', 'week' ] } } },
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'dem_venda__produto_data_ini_fim':
            field = {
              cod_venda: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'min', 'max' ] } } },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break

          case 'dem_venda__servico':
            field = {
              id: null,
              cod_venda: { a: 'demandaId', j: { vencimento: { a: 'demandaId_data' }, status: { a: 'demandaId_status' }, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } } } },
              id_ser: { a: 'item', j: { id: { a: 'item_codigo' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } },
              qtde: null,
              valor_uni: null,
              valor_tot: null
            }
            break
          case 'dem_venda__servico_qtde':
            field = {
              qtde: { o: 'sum' },
              valor_tot: { o: 'sum' },
              cod_venda: { o: 'countDistinct', a: 'qtde_demanda', j: { vencimento: { a: '_REMOVER_' } } },
              id: { o: 'count', a: 'qtde_itens' },
              id_ser: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' } } }
            }
            break
          case 'dem_venda__servico_grafico':
            field = {
              cod_venda: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'day', 'month', 'year', 'week' ] } } },
              qtde: { o: 'sum' },
              valor_tot: { o: 'sum' },
              id_ser: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' } } }
            }
            break
          case 'dem_venda__servico_data_ini_fim':
            field = {
              cod_venda: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'min', 'max' ] } } },
              id_ser: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' } } }
            }
            break

          case 'dem_compra':
            field = {
              id: null,
              dem_compra: { a: 'demandaId', j: { vencimento: { a: 'demandaId_data' }, dem_status: { a: 'demandaId_status' }, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } } } },
              id_pro: { a: 'item', j: { codigo: { a: 'item_codigo' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } },
              qtde: null,
              valor_uni_novo: { a: 'valor_uni' },
              valor_tot_novo: { a: 'valor_tot' },
              valor_fre: null,
              valor_seg: null,
              valor_des_novo: { a: 'valor_des' },
              valor_oda: null,
              p_ipi_v: null,
              p_icms_st_v: null,
              p_icms_fcp_st_v: null
            }
            break
          case 'dem_compra_qtde':
            field = {
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              dem_compra: { o: 'countDistinct', a: 'qtde_demanda', j: { vencimento: { a: '_REMOVER_' } } },
              id: { o: 'count', a: 'qtde_itens' },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'dem_compra_grafico':
            field = {
              dem_compra: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'day', 'month', 'year', 'week' ] } } },
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'dem_compra_data_ini_fim':
            field = {
              dem_compra: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'min', 'max' ] } } },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break

          case 'dem_dev_fornecedor':
            field = {
              id: null,
              dem_dev_fornecedor: { a: 'demandaId', j: { vencimento: { a: 'demandaId_data' }, status: { a: 'demandaId_status' }, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } } } },
              id_pro: { a: 'item', j: { codigo: { a: 'item_codigo' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } },
              qtde: null,
              valor_uni_novo: { a: 'valor_uni' },
              valor_tot_novo: { a: 'valor_tot' },
              valor_fre: null,
              valor_seg: null,
              valor_des_novo: { a: 'valor_des' },
              valor_oda: null,
              p_ipi_v: null,
              p_icms_st_v: null,
              p_icms_fcp_st_v: null
            }
            break
          case 'dem_dev_fornecedor_qtde':
            field = {
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              dem_dev_fornecedor: { o: 'countDistinct', a: 'qtde_demanda', j: { vencimento: { a: '_REMOVER_' } } },
              id: { o: 'count', a: 'qtde_itens' },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'dem_dev_fornecedor_grafico':
            field = {
              dem_dev_fornecedor: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'day', 'month', 'year', 'week' ] } } },
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'dem_dev_fornecedor_data_ini_fim':
            field = {
              dem_dev_fornecedor: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'min', 'max' ] } } },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break

          case 'dem_dev_cliente':
            field = {
              id: null,
              dem_dev_cliente: { a: 'demandaId', j: { vencimento: { a: 'demandaId_data' }, status: { a: 'demandaId_status' }, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } } } },
              id_pro: { a: 'item', j: { codigo: { a: 'item_codigo' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } },
              qtde: null,
              valor_uni_novo: { a: 'valor_uni' },
              valor_tot_novo: { a: 'valor_tot' },
              valor_fre: null,
              valor_seg: null,
              valor_des_novo: { a: 'valor_des' },
              valor_oda: null,
              p_ipi_v: null,
              p_icms_st_v: null,
              p_icms_fcp_st_v: null
            }
            break
          case 'dem_dev_cliente_qtde':
            field = {
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              dem_dev_cliente: { o: 'countDistinct', a: 'qtde_demanda', j: { vencimento: { a: '_REMOVER_' } } },
              id: { o: 'count', a: 'qtde_itens' },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'dem_dev_cliente_grafico':
            field = {
              dem_dev_cliente: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'day', 'month', 'year', 'week' ] } } },
              qtde: { o: 'sum' },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_ipi_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'dem_dev_cliente_data_ini_fim':
            field = {
              dem_dev_cliente: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'min', 'max' ] } } },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break

          case 'fabricacao':
            field = {
              id: null,
              id_pro: { a: 'item', j: { codigo: { a: 'item_codigo' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } },
              qtde_fabricada: { a: 'qtde' },
              data_fabricacao: { a: 'last_at_ptbr' },
              // last_at: null,
              // last_user: { j: { usuario: null } }
            }
            break
          case 'fabricacao_qtde':
            field = {
              qtde_fabricada: { a: 'qtde', o: 'sum' },
              // valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              // valor_fre: { o: 'sum' },
              // valor_seg: { o: 'sum' },
              // valor_des_novo: { a: 'valor_des', o: 'sum' },
              // valor_oda: { o: 'sum' },
              // p_ipi_v: { o: 'sum' },
              // p_icms_st_v: { o: 'sum' },
              // p_icms_fcp_st_v: { o: 'sum' },
              id: { o: 'count', a: 'qtde_itens' },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'fabricacao_grafico':
            field = {
              last_at: { a: 'vcto', o: [ 'day', 'month', 'year', 'week' ] },
              qtde_fabricada: { a: 'qtde', o: 'sum' },
              // valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              // valor_fre: { o: 'sum' },
              // valor_seg: { o: 'sum' },
              // valor_des_novo: { a: 'valor_des', o: 'sum' },
              // valor_oda: { o: 'sum' },
              // p_ipi_v: { o: 'sum' },
              // p_icms_st_v: { o: 'sum' },
              // p_icms_fcp_st_v: { o: 'sum' },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'fabricacao_data_ini_fim':
            field = {
              last_at: { a: 'vcto', o: [ 'min', 'max' ] },
              id_pro: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break

          case 'insumo':
            field = {
              id: null,
              id_pro_consumido: { a: 'item', j: { codigo: { a: 'item_codigo' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } },
              qtde: null,
              cod_venda: null,
              id_produto_fabricado: null,
              last_at: null,
              last_user: { j: { usuario: null } }
            }
            break
          case 'insumo_qtde':
            field = {
              qtde: { o: 'sum' },
              // valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              // valor_fre: { o: 'sum' },
              // valor_seg: { o: 'sum' },
              // valor_des_novo: { a: 'valor_des', o: 'sum' },
              // valor_oda: { o: 'sum' },
              // p_ipi_v: { o: 'sum' },
              // p_icms_st_v: { o: 'sum' },
              // p_icms_fcp_st_v: { o: 'sum' },
              cod_venda: { o: 'count' },
              id_produto_fabricado: { o: 'count' },
              id: { o: 'count', a: 'qtde_itens' },
              id_pro_consumido: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'insumo_grafico':
            field = {
              last_at: { a: 'vcto', o: [ 'day', 'month', 'year', 'week' ] },
              qtde: { o: 'sum' },
              // valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              // valor_fre: { o: 'sum' },
              // valor_seg: { o: 'sum' },
              // valor_des_novo: { a: 'valor_des', o: 'sum' },
              // valor_oda: { o: 'sum' },
              // p_ipi_v: { o: 'sum' },
              // p_icms_st_v: { o: 'sum' },
              // p_icms_fcp_st_v: { o: 'sum' },
              id_pro_consumido: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
          case 'insumo_data_ini_fim':
            field = {
              last_at: { a: 'vcto', o: [ 'min', 'max' ] },
              id_pro_consumido: { a: '_REMOVER_', j: { id_cat: { a: '_REMOVER_' }, id_mar: { a: '_REMOVER_' } } }
            }
            break
        }

        // VERIFICA SE TEM QUE ADICIONAR UM CAMPO PARA COLOCAR O GROUP
        if (demanda.indexOf('_qtde') !== -1) { 
          field.status = null
        }

        // RETORNA OS FIELDS MONTADOS
        return field
      },
      appHisMontarWhere: function (demanda) {
        // INICIA A VARIAVEL
        var status = []

        // INICIA O WHERE QUE SERÁ REALIZADO
        var where = {}

        // VERIFICA A DEMANDA QUE ESTÁ SENDO TRATADA
        switch (demanda) {
          case 'dem_venda__produto':
          case 'dem_venda__produto_qtde':
          case 'dem_venda__produto_grafico':
          case 'dem_venda__produto_data_ini_fim':
            // INICIA O WHERE
            where = { aAnd: [
              { f: 'status', o: '=', v: '1' },
              { m: 'venda', f: 'status', o: '<>', v: '3' } ,
            ] }
            
            // VERIFICA POSSIVEL PERSONALIZAÇÃO
            if ([ '2298', '8007', '1933' ].indexOf(this.$store.state.token.clu) !== -1) {
              where.aAnd.push({
                aOr: [
                  { m: 'venda', f: 'p_doc_ope', o: 'isNull' },
                  { m: 'venda', f: 'p_doc_ope', o: '=', v: '1' },
                  { m: 'venda', f: 'p_doc_ope', o: '=', v: '0' }
                ]
              })
            } else {
              where.aAnd.push({
                aOr: [
                  { m: 'venda', f: 'p_doc_ope', o: 'isNull' },
                  { m: 'venda', f: 'p_doc_ope', o: '=', v: '1' }
                ]
              })
            }

            // VERIFICA O STATUS QUE DEVE BUSCAR
            if (this.filtros.dem_sta !== '') {
              // PEGA OS STATUS DA VENDA
              status = this.filtros.dem_sta.filter(item => [ 'dem_venda__1', 'dem_venda__2' ].indexOf(item) !== -1)

              // SÓ COLOCA ESSA INFORMAÇÃO SE FOR 1 STATUS APENAS, POIS SE FOR OS DOIS O SISTEMA JÁ BUSCA SEM ESSA CLAUSULA
              if (status.length === 1) {
                where.aAnd.push({ m: 'venda', f: 'status', o: '=', v: status[0].replace('dem_venda__', '').toString() })
              }
            }

            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }

            // SETA A BUSCA DO VEICULO SOLICITADO
            if (this.filtros.vei === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: '=', v: '0' })
            } else if (this.filtros.vei !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: 'in', v: this.filtros.vei.join() })
            }

            // SETA A BUSCA DO PET SOLICITADO
            if (this.filtros.pet === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'isNull' })
            } else if (this.filtros.pet !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'in', v: this.filtros.pet.join() })
            }

            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: 'venda', f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: 'venda', f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
            break

          case 'dem_venda__servico':
          case 'dem_venda__servico_qtde':
          case 'dem_venda__servico_grafico':
          case 'dem_venda__servico_data_ini_fim':
            // INICIA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'venda', f: 'status', o: '<>', v: '3' } ] }

            // VERIFICA O STATUS QUE DEVE BUSCAR
            if (this.filtros.dem_sta !== '') {
              // PEGA OS STATUS DA VENDA
              status = this.filtros.dem_sta.filter(item => [ 'dem_venda__1', 'dem_venda__2' ].indexOf(item) !== -1)

              // SÓ COLOCA ESSA INFORMAÇÃO SE FOR 1 STATUS APENAS, POIS SE FOR OS DOIS O SISTEMA JÁ BUSCA SEM ESSA CLAUSULA
              if (status.length === 1) {
                where.aAnd.push({ m: 'venda', f: 'status', o: '=', v: status[0].replace('dem_venda__', '').toString() })
              }
            }

            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }

            // SETA A BUSCA DO VEICULO SOLICITADO
            if (this.filtros.vei === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: '=', v: '' })
            } else if (this.filtros.vei !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: 'in', v: this.filtros.vei.join() })
            }

            // SETA A BUSCA DO PET SOLICITADO
            if (this.filtros.pet === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: '=', v: '' })
            } else if (this.filtros.pet !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'in', v: this.filtros.pet.join() })
            }

            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.ser !== '') {
              where.aAnd.push({ f: 'id_ser', o: 'in', v: this.filtros.ser.join() })
            }
    
            // SETA A BUSCA DO CATEGORIA DE SERVIÇO ESPECIFICADO
            if (this.filtros.ser_cat !== '') {
              where.aAnd.push({ m: 'servico', f: 'id_cat', o: 'in', v: this.filtros.ser_cat.join() })
            }

            
            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: 'venda', f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: 'venda', f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
            break

          case 'dem_compra':
          case 'dem_compra_qtde':
          case 'dem_compra_grafico':
          case 'dem_compra_data_ini_fim':
            // INICIA O WHERE
            where = { aAnd: [
              { f: 'status', o: '=', v: '1' },
              { m: 'demanda', f: 'dem_status', o: '<>', v: '3' },
              {
                aOr: [
                  { m: 'demanda', f: 'p_doc_ope', o: 'isNull' },
                  { m: 'demanda', f: 'p_doc_ope', o: '=', v: '0' }
                ]
              }
            ] }

            // VERIFICA O STATUS QUE DEVE BUSCAR
            if (this.filtros.dem_sta !== '') {
              // PEGA OS STATUS DA VENDA
              status = this.filtros.dem_sta.filter(item => [ 'dem_compra__1', 'dem_compra__2' ].indexOf(item) !== -1)

              // SÓ COLOCA ESSA INFORMAÇÃO SE FOR 1 STATUS APENAS, POIS SE FOR OS DOIS O SISTEMA JÁ BUSCA SEM ESSA CLAUSULA
              if (status.length === 1) {
                where.aAnd.push({ m: 'demanda', f: 'dem_status', o: '=', v: status[0].replace('dem_compra__', '').toString() })
              }
            }

            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: 'demanda', f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }

            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: 'demanda', f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: 'demanda', f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
            break

          case 'dem_dev_fornecedor':
          case 'dem_dev_fornecedor_qtde':
          case 'dem_dev_fornecedor_grafico':
          case 'dem_dev_fornecedor_data_ini_fim':
          case 'dem_dev_cliente':
          case 'dem_dev_cliente_qtde':
          case 'dem_dev_cliente_grafico':
          case 'dem_dev_cliente_data_ini_fim':
            // INICIA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'demanda', f: 'status', o: '<>', v: '3' } ] }

            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: 'demanda', f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }

            
            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: 'demanda', f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: 'demanda', f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
            break

          case 'fabricacao':
          case 'fabricacao_qtde':
          case 'fabricacao_grafico':
          case 'fabricacao_data_ini_fim':
            // INICIA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }
            
            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { f: 'data_fabricacao', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { f: 'data_fabricacao', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }

            // VERIFICA O FILTRO DE PRODUTO
            if (this.filtros.pro === '__NENHUM__') {
              where.aAnd.push({ f: 'id_pro', o: '=', v: '' })
            } else {
              // SETA A BUSCA DO PRODUTO ESPECIFICADO
              if (this.filtros.pro !== '') {
                where.aAnd.push({ f: 'id_pro', o: 'in', v: this.filtros.pro.join() })
              }
      
              // SETA A BUSCA DO CATEGORIA DE PRODUTO ESPECIFICADO
              if (this.filtros.pro_cat !== '') {
                where.aAnd.push({ m: 'produto', f: 'id_cat', o: 'in', v: this.filtros.pro_cat.join() })
              }
      
              // SETA A BUSCA DO MARCA DE PRODUTO ESPECIFICADO
              if (this.filtros.pro_mar !== '') {
                where.aAnd.push({ m: 'produto', f: 'id_mar', o: 'in', v: this.filtros.pro_mar.join() })
              }
            }
            break

          case 'insumo':
          case 'insumo_qtde':
          case 'insumo_grafico':
          case 'insumo_data_ini_fim':
            // INICIA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }
            
            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { f: 'last_at', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { f: 'last_at', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }

            // VERIFICA O FILTRO DE PRODUTO
            if (this.filtros.pro === '__NENHUM__') {
              where.aAnd.push({ f: 'id_pro_consumido', o: '=', v: '' })
            } else {
              // SETA A BUSCA DO PRODUTO ESPECIFICADO
              if (this.filtros.pro !== '') {
                where.aAnd.push({ f: 'id_pro_consumido', o: 'in', v: this.filtros.pro.join() })
              }
      
              // SETA A BUSCA DO CATEGORIA DE PRODUTO ESPECIFICADO
              if (this.filtros.pro_cat !== '') {
                where.aAnd.push({ m: 'produto', f: 'id_cat', o: 'in', v: this.filtros.pro_cat.join() })
              }
      
              // SETA A BUSCA DO MARCA DE PRODUTO ESPECIFICADO
              if (this.filtros.pro_mar !== '') {
                where.aAnd.push({ m: 'produto', f: 'id_mar', o: 'in', v: this.filtros.pro_mar.join() })
              }
            }
            break
        }

        // VERIFICA SE DEVE INCLUIR FILTRO DE PESQUISA DE PRODUTO
        if (demanda.indexOf('servico') === -1 && [ 'dem_venda__servico', 'dem_venda__servico_qtde', 'insumo', 'insumo_qtde', 'insumo_grafico', 'insumo_data_ini_fim', 'fabricacao', 'fabricacao_qtde', 'fabricacao_grafico', 'fabricacao_data_ini_fim' ].indexOf(demanda) === -1) {
          if (this.filtros.pro === '__NENHUM__') {
            where.aAnd.push({ f: 'id_pro', o: '=', v: '' })
          } else {
            // SETA A BUSCA DO PRODUTO ESPECIFICADO
            if (this.filtros.pro !== '') {
              where.aAnd.push({ f: 'id_pro', o: 'in', v: this.filtros.pro.join() })
            }
    
            // SETA A BUSCA DO CATEGORIA DE PRODUTO ESPECIFICADO
            if (this.filtros.pro_cat !== '') {
              where.aAnd.push({ m: 'produto', f: 'id_cat', o: 'in', v: this.filtros.pro_cat.join() })
            }
    
            // SETA A BUSCA DO MARCA DE PRODUTO ESPECIFICADO
            if (this.filtros.pro_mar !== '') {
              where.aAnd.push({ m: 'produto', f: 'id_mar', o: 'in', v: this.filtros.pro_mar.join() })
            }
          }
        }

        // RETORNA O WHERE MONTADO
        return where
      },
      appHisSetarTotais: function (retorno) {
        // IMPORTA A FUNÇAO
        const CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM = require('@/assets/js/Funcoes-Gerais.js').CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM

        // INICIA A VARIAVEL
        var pesquisa = typeof this.pesquisa === 'object' ? this.pesquisa : {}

        // INICIA A VARIAVEL DO GRAFICO
        var grafico = {}

        // OCULTA O GRAFICO
        this.grafico = null

        // PEGA AS CHAVES DO RETORNO
        var keys = Object.keys(retorno)

        // VERIFICA SE TEM A PESQUISA DESEJADA
        if (keys.indexOf('dem_compra') !== -1 || keys.indexOf('dem_compra_qtde') !== -1) {
          // INICIA A CHAVE
          pesquisa.dem_compra = { chave: 'dem_compra', nome: 'Compra', disabled: false, carregado: false, mostrar: false, linhas: [], countAll: '0' }

          // VERIFICA SE RECEBEU A LISTA DE DADOS
          if (keys.indexOf('dem_compra') !== -1) {
            pesquisa.dem_compra.linhas = retorno.dem_compra.data
            pesquisa.dem_compra.countAll = retorno.dem_compra.countAll
          }
          if (keys.indexOf('dem_compra_qtde') !== -1) {
            pesquisa.dem_compra.totais = retorno.dem_compra_qtde.data.length >= 1 ? CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(retorno.dem_compra_qtde.data[0], 'produto', {
              qtde:             'qtde_sum',
              valor_tot:        'valor_tot_sum',
              valor_fre:        'valor_fre_sum',
              valor_seg:        'valor_seg_sum',
              valor_des:        'valor_des_sum',
              valor_oda:        'valor_oda_sum',
              p_icms_st_v:      'p_icms_st_v_sum',
              p_icms_fcp_st_v:  'p_icms_fcp_st_v_sum',
              p_ipi_v:          'p_ipi_v_sum'
            }) : { qtde_sum: 0, _qtde_sum: '0,00', valor_tot_sum: 0, _valor_tot_sum: '0,00', valor_fre_sum: 0, _valor_fre_sum: '0,00', valor_seg_sum: 0, _valor_seg_sum: '0,00', valor_des_sum: 0, _valor_des_sum: '0,00', valor_oda_sum: 0, _valor_oda_sum: '0,00', p_icms_st_v_sum: 0, _p_icms_st_v_sum: '0,00', p_icms_fcp_st_v_sum: 0, _p_icms_fcp_st_v_sum: '0,00', p_ipi_v_sum: 0, _p_ipi_v_sum: '0,00', total: 0, _total: '0,00', countAll: '0' }

            pesquisa.dem_compra.totais.detalhes = false
          }
        }

        // VERIFICA SE TEM A PESQUISA DESEJADA
        if (keys.indexOf('dem_dev_fornecedor') !== -1 || keys.indexOf('dem_dev_fornecedor_qtde') !== -1) {
          // INICIA A CHAVE
          pesquisa.dem_dev_fornecedor = { chave: 'dem_dev_fornecedor', nome: 'Dev. Fornecedor', disabled: false, carregado: false, mostrar: false, linhas: [], countAll: '0' }

          // VERIFICA SE RECEBEU A LISTA DE DADOS
          if (keys.indexOf('dem_dev_fornecedor') !== -1) {
            pesquisa.dem_dev_fornecedor.linhas = retorno.dem_dev_fornecedor.data
            pesquisa.dem_dev_fornecedor.countAll = retorno.dem_dev_fornecedor.countAll
          }
          if (keys.indexOf('dem_dev_fornecedor_qtde') !== -1) {
            pesquisa.dem_dev_fornecedor.totais = retorno.dem_dev_fornecedor_qtde.data.length >= 1 ? CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(retorno.dem_dev_fornecedor_qtde.data[0], 'produto', {
              qtde:             'qtde_sum',
              valor_tot:        'valor_tot_sum',
              valor_fre:        'valor_fre_sum',
              valor_seg:        'valor_seg_sum',
              valor_des:        'valor_des_sum',
              valor_oda:        'valor_oda_sum',
              p_icms_st_v:      'p_icms_st_v_sum',
              p_icms_fcp_st_v:  'p_icms_fcp_st_v_sum',
              p_ipi_v:          'p_ipi_v_sum'
            }) : { qtde_sum: 0, _qtde_sum: '0,00', valor_tot_sum: 0, _valor_tot_sum: '0,00', valor_fre_sum: 0, _valor_fre_sum: '0,00', valor_seg_sum: 0, _valor_seg_sum: '0,00', valor_des_sum: 0, _valor_des_sum: '0,00', valor_oda_sum: 0, _valor_oda_sum: '0,00', p_icms_st_v_sum: 0, _p_icms_st_v_sum: '0,00', p_icms_fcp_st_v_sum: 0, _p_icms_fcp_st_v_sum: '0,00', p_ipi_v_sum: 0, _p_ipi_v_sum: '0,00', total: 0, _total: '0,00', countAll: '0' }
            pesquisa.dem_dev_fornecedor.totais.detalhes = false
          }
        }

        // VERIFICA SE TEM A PESQUISA DESEJADA
        if (keys.indexOf('fabricacao') !== -1 || keys.indexOf('fabricacao_qtde') !== -1) {
          // INICIA A CHAVE
          pesquisa.fabricacao = { chave: 'fabricacao', nome: 'Fabricação - Produto Acabado', disabled: false, carregado: false, mostrar: false, linhas: [], countAll: '0' }

          // VERIFICA SE RECEBEU A LISTA DE DADOS
          if (keys.indexOf('fabricacao') !== -1) {
            pesquisa.fabricacao.linhas = retorno.fabricacao.data
            pesquisa.fabricacao.countAll = retorno.fabricacao.countAll
          }
          if (keys.indexOf('fabricacao_qtde') !== -1) {
            if (retorno.fabricacao_qtde.data.length >= 1) {
              retorno.fabricacao_qtde.data[0].qtde_demanda = (Number(retorno.fabricacao_qtde.data[0].cod_venda_count) + Number(retorno.fabricacao_qtde.data[0].id_produto_fabricado_count)).toString()
            }

            pesquisa.fabricacao.totais = retorno.fabricacao_qtde.data.length >= 1 ? CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(retorno.fabricacao_qtde.data[0], 'produto', {
              qtde:             'qtde_sum',
              valor_tot:        'valor_tot_sum',
              valor_fre:        'valor_fre_sum',
              valor_seg:        'valor_seg_sum',
              valor_des:        'valor_des_sum',
              valor_oda:        'valor_oda_sum',
              p_icms_st_v:      'p_icms_st_v_sum',
              p_icms_fcp_st_v:  'p_icms_fcp_st_v_sum',
              p_ipi_v:          'p_ipi_v_sum'
            }) : { qtde_sum: 0, _qtde_sum: '0,00', valor_tot_sum: 0, _valor_tot_sum: '0,00', valor_fre_sum: 0, _valor_fre_sum: '0,00', valor_seg_sum: 0, _valor_seg_sum: '0,00', valor_des_sum: 0, _valor_des_sum: '0,00', valor_oda_sum: 0, _valor_oda_sum: '0,00', p_icms_st_v_sum: 0, _p_icms_st_v_sum: '0,00', p_icms_fcp_st_v_sum: 0, _p_icms_fcp_st_v_sum: '0,00', p_ipi_v_sum: 0, _p_ipi_v_sum: '0,00', total: 0, _total: '0,00', countAll: '0' }
            pesquisa.fabricacao.totais.detalhes = false
          }
        }

        // VERIFICA SE TEM A PESQUISA DESEJADA
        if (keys.indexOf('insumo') !== -1 || keys.indexOf('insumo_qtde') !== -1) {
          // INICIA A CHAVE
          pesquisa.insumo = { chave: 'insumo', nome: 'Fabricação - Insumo', disabled: false, carregado: false, mostrar: false, linhas: [], countAll: '0' }

          // VERIFICA SE RECEBEU A LISTA DE DADOS
          if (keys.indexOf('insumo') !== -1) {
            pesquisa.insumo.linhas = retorno.insumo.data
            pesquisa.insumo.countAll = retorno.insumo.countAll
          }
          if (keys.indexOf('insumo_qtde') !== -1) {
            if (retorno.insumo_qtde.data.length >= 1) {
              retorno.insumo_qtde.data[0].qtde_demanda = (Number(retorno.insumo_qtde.data[0].cod_venda_count) + Number(retorno.insumo_qtde.data[0].id_produto_fabricado_count)).toString()
            }

            pesquisa.insumo.totais = retorno.insumo_qtde.data.length >= 1 ? CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(retorno.insumo_qtde.data[0], 'produto', {
              qtde:             'qtde_sum',
              valor_tot:        'valor_tot_sum',
              valor_fre:        'valor_fre_sum',
              valor_seg:        'valor_seg_sum',
              valor_des:        'valor_des_sum',
              valor_oda:        'valor_oda_sum',
              p_icms_st_v:      'p_icms_st_v_sum',
              p_icms_fcp_st_v:  'p_icms_fcp_st_v_sum',
              p_ipi_v:          'p_ipi_v_sum'
            }) : { qtde_sum: 0, _qtde_sum: '0,00', valor_tot_sum: 0, _valor_tot_sum: '0,00', valor_fre_sum: 0, _valor_fre_sum: '0,00', valor_seg_sum: 0, _valor_seg_sum: '0,00', valor_des_sum: 0, _valor_des_sum: '0,00', valor_oda_sum: 0, _valor_oda_sum: '0,00', p_icms_st_v_sum: 0, _p_icms_st_v_sum: '0,00', p_icms_fcp_st_v_sum: 0, _p_icms_fcp_st_v_sum: '0,00', p_ipi_v_sum: 0, _p_ipi_v_sum: '0,00', total: 0, _total: '0,00', countAll: '0' }
            pesquisa.insumo.totais.detalhes = false
          }
        }

        // VERIFICA SE TEM A PESQUISA DESEJADA
        if (keys.indexOf('dem_venda__produto') !== -1 || keys.indexOf('dem_venda__produto_qtde') !== -1 || keys.indexOf('dem_venda__servico') !== -1 || keys.indexOf('dem_venda__servico_qtde') !== -1) {
          // INICIA A VARIAVEL
          if ([ '', null, undefined ].indexOf(pesquisa.dem_venda) !== -1 || [ '', null, undefined ].indexOf(pesquisa.dem_venda.totais) !== -1) {
            pesquisa.dem_venda = { chave: 'dem_venda', nome: 'Venda', disabled: false, carregado: false, mostrar: false, totais: { qtde_sum: 0, _qtde_sum: '0,00', valor_tot_sum: 0, _valor_tot_sum: '0,00', valor_fre_sum: 0, _valor_fre_sum: '0,00', valor_seg_sum: 0, _valor_seg_sum: '0,00', valor_des_sum: 0, _valor_des_sum: '0,00', valor_oda_sum: 0, _valor_oda_sum: '0,00', p_icms_st_v_sum: 0, _p_icms_st_v_sum: '0,00', p_icms_fcp_st_v_sum: 0, _p_icms_fcp_st_v_sum: '0,00', p_ipi_v_sum: 0, _p_ipi_v_sum: '0,00', total: 0, _total: '0,00', countAll: '0' }, produto: {  linhas: [], totais: {}, countAll: '0' }, servico: {  linhas: [], totais: {}, countAll: '0' } }
            pesquisa.dem_venda.totais.detalhes = false
          }

          // VERIFICA SE TEM RETORNO DE PRODUTO
          if (keys.indexOf('dem_venda__produto') !== -1) {
            pesquisa.dem_venda.produto.countAll = retorno.dem_venda__produto.countAll
            pesquisa.dem_venda.produto.linhas = retorno.dem_venda__produto.data
          }
          if (keys.indexOf('dem_venda__produto_qtde') !== -1) {
            pesquisa.dem_venda.produto.totais = retorno.dem_venda__produto_qtde.data.length >= 1 ? CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(retorno.dem_venda__produto_qtde.data[0], 'produto', {
              qtde:             'qtde_sum',
              valor_tot:        'valor_tot_sum',
              valor_fre:        'valor_fre_sum',
              valor_seg:        'valor_seg_sum',
              valor_des:        'valor_des_sum',
              valor_oda:        'valor_oda_sum',
              p_icms_st_v:      'p_icms_st_v_sum',
              p_icms_fcp_st_v:  'p_icms_fcp_st_v_sum',
              p_ipi_v:          'p_ipi_v_sum'
            }) : { qtde_sum: 0, _qtde_sum: '0,00', valor_tot_sum: 0, _valor_tot_sum: '0,00', valor_fre_sum: 0, _valor_fre_sum: '0,00', valor_seg_sum: 0, _valor_seg_sum: '0,00', valor_des_sum: 0, _valor_des_sum: '0,00', valor_oda_sum: 0, _valor_oda_sum: '0,00', p_icms_st_v_sum: 0, _p_icms_st_v_sum: '0,00', p_icms_fcp_st_v_sum: 0, _p_icms_fcp_st_v_sum: '0,00', p_ipi_v_sum: 0, _p_ipi_v_sum: '0,00', total: 0, _total: '0,00', countAll: '0' }
            pesquisa.dem_venda.produto.totais.detalhes = false
          }

          // VERIFICA SE TEM RETORNO DE SERVIÇO
          if (keys.indexOf('dem_venda__servico') !== -1) {
            pesquisa.dem_venda.servico.countAll = retorno.dem_venda__servico.countAll
            pesquisa.dem_venda.servico.linhas = retorno.dem_venda__servico.data
          }
          if (keys.indexOf('dem_venda__servico_qtde') !== -1) {
            pesquisa.dem_venda.servico.totais = retorno.dem_venda__servico_qtde.data.length >= 1 ? CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(retorno.dem_venda__servico_qtde.data[0], 'servico', {
              qtde:       'qtde_sum',
              valor_tot:  'valor_tot_sum'
            }) : { qtde_sum: 0, _qtde_sum: '0,00', valor_tot_sum: 0, _valor_tot_sum: '0,00', valor_fre_sum: 0, _valor_fre_sum: '0,00', valor_seg_sum: 0, _valor_seg_sum: '0,00', valor_des_sum: 0, _valor_des_sum: '0,00', valor_oda_sum: 0, _valor_oda_sum: '0,00', p_icms_st_v_sum: 0, _p_icms_st_v_sum: '0,00', p_icms_fcp_st_v_sum: 0, _p_icms_fcp_st_v_sum: '0,00', p_ipi_v_sum: 0, _p_ipi_v_sum: '0,00', total: 0, _total: '0,00', countAll: '0' }
            pesquisa.dem_venda.servico.totais.detalhes = false
          }
        }
        if ([ '', null, undefined ].indexOf(pesquisa.dem_venda) === -1) {
          if ([ '', null, undefined ].indexOf(pesquisa.dem_venda.produto) === -1 && [ '', null, undefined ].indexOf(pesquisa.dem_venda.produto.totais) === -1 && Object.keys(pesquisa.dem_venda.produto.totais).length >= 1) {
            pesquisa.dem_venda.totais = pesquisa.dem_venda.produto.totais
          }
          if ([ '', null, undefined ].indexOf(pesquisa.dem_venda.servico) === -1 && [ '', null, undefined ].indexOf(pesquisa.dem_venda.servico.totais) === -1 && Object.keys(pesquisa.dem_venda.servico.totais).length >= 1) {
            pesquisa.dem_venda.totais.qtde_sum = Number(pesquisa.dem_venda.totais.qtde_sum) + Number(pesquisa.dem_venda.servico.totais.qtde_sum)
            pesquisa.dem_venda.totais.valor_tot_sum = Number(pesquisa.dem_venda.totais.valor_tot_sum) + Number(pesquisa.dem_venda.servico.totais.valor_tot_sum)
            pesquisa.dem_venda.totais.total = Number(pesquisa.dem_venda.totais.total) + Number(pesquisa.dem_venda.servico.totais.valor_tot_sum)
          }
          if ([ '', null, undefined ].indexOf(pesquisa.dem_venda.totais) === -1 && Object.keys(pesquisa.dem_venda.totais).length >= 1) {
            pesquisa.dem_venda.totais.total = Number(pesquisa.dem_venda.totais.total).toFixed(2)
            if (Number(pesquisa.dem_venda.totais.total) > 0) {
              pesquisa.dem_venda.totais._total = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', pesquisa.dem_venda.totais.total.toString())
            }
          }
        }
        
        // VERIFICA SE TEM A PESQUISA DESEJADA
        if (keys.indexOf('dem_dev_cliente') !== -1 || keys.indexOf('dem_dev_cliente_qtde') !== -1) {
          // INICIA A CHAVE
          pesquisa.dem_dev_cliente = { chave: 'dem_dev_cliente', nome: 'Dev. Cliente', disabled: false, carregado: false, mostrar: false, linhas: [], countAll: '0' }

          // VERIFICA SE RECEBEU A LISTA DE DADOS
          if (keys.indexOf('dem_dev_cliente') !== -1) {
            pesquisa.dem_dev_cliente.linhas = retorno.dem_dev_cliente.data
            pesquisa.dem_dev_cliente.countAll = retorno.dem_dev_cliente.countAll
          }
          if (keys.indexOf('dem_dev_cliente_qtde') !== -1) {
            pesquisa.dem_dev_cliente.totais = retorno.dem_dev_cliente_qtde.data.length >= 1 ? CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(retorno.dem_dev_cliente_qtde.data[0], 'produto', {
              qtde:             'qtde_sum',
              valor_tot:        'valor_tot_sum',
              valor_fre:        'valor_fre_sum',
              valor_seg:        'valor_seg_sum',
              valor_des:        'valor_des_sum',
              valor_oda:        'valor_oda_sum',
              p_icms_st_v:      'p_icms_st_v_sum',
              p_icms_fcp_st_v:  'p_icms_fcp_st_v_sum',
              p_ipi_v:          'p_ipi_v_sum'
            }) : { qtde_sum: 0, _qtde_sum: '0,00', valor_tot_sum: 0, _valor_tot_sum: '0,00', valor_fre_sum: 0, _valor_fre_sum: '0,00', valor_seg_sum: 0, _valor_seg_sum: '0,00', valor_des_sum: 0, _valor_des_sum: '0,00', valor_oda_sum: 0, _valor_oda_sum: '0,00', p_icms_st_v_sum: 0, _p_icms_st_v_sum: '0,00', p_icms_fcp_st_v_sum: 0, _p_icms_fcp_st_v_sum: '0,00', p_ipi_v_sum: 0, _p_ipi_v_sum: '0,00', total: 0, _total: '0,00', countAll: '0' }
            pesquisa.dem_dev_cliente.totais.detalhes = false
          }
        }

        // FAZ A FORMATAÇÃO DOS CAMPOS
        for (var index in pesquisa) {
          if ([ '', null, undefined ].indexOf(pesquisa[index].totais) === -1 && Object.keys(pesquisa[index].totais).length >= 1) {
            pesquisa[index].totais._qtde_sum = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', pesquisa[index].totais.qtde_sum)
            if ([ '', null, undefined, NaN ].indexOf(pesquisa[index].totais.valor_tot_sum) === -1 && isNaN(pesquisa[index].totais.valor_tot_sum) === false) {
              pesquisa[index].totais._valor_tot_sum = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', pesquisa[index].totais.valor_tot_sum)
            }
          }

          // VERIFICA SE TEM VALOR NA PARTE DE VENDA
          if (index === 'dem_venda') {
            // INICIA O VALOR
            pesquisa[index].countAll = 0

            // SOMA O VALOR DO PRODUTO
            if (pesquisa[index].produto !== undefined) {
              pesquisa[index].countAll += Number(pesquisa[index].produto.countAll)
            }

            // SOMA O VALOR DO SERVICO
            if (pesquisa[index].servico !== undefined) {
              pesquisa[index].countAll += Number(pesquisa[index].servico.countAll)
            }

            // CONVERTE EM TEXTO O VALOR
            pesquisa[index].countAll = pesquisa[index].countAll.toString()
          }

          // DESATIVA A ABA
          pesquisa[index].disabled = Number(pesquisa[index].countAll) <= 0
        }
        
        // VERIFICA SE TEM GRAFICO RECEBIDO
        if (keys.indexOf('fabricacao_grafico') !== -1 && retorno.fabricacao_grafico.data.length >= 1) {
          grafico.fabricacao = retorno.fabricacao_grafico.data
        }
        if (keys.indexOf('insumo_grafico') !== -1 && retorno.insumo_grafico.data.length >= 1) {
          grafico.insumo = retorno.insumo_grafico.data
        }
        if (keys.indexOf('dem_compra_grafico') !== -1 && retorno.dem_compra_grafico.data.length >= 1) {
          grafico.dem_compra = retorno.dem_compra_grafico.data
        }
        if (keys.indexOf('dem_dev_fornecedor_grafico') !== -1 && retorno.dem_dev_fornecedor_grafico.data.length >= 1) {
          grafico.dem_dev_fornecedor = retorno.dem_dev_fornecedor_grafico.data
        }
        if (keys.indexOf('dem_venda__produto_grafico') !== -1 && retorno.dem_venda__produto_grafico.data.length >= 1) {
          grafico.dem_venda_produto = retorno.dem_venda__produto_grafico.data
        }
        if (keys.indexOf('dem_venda__servico_grafico') !== -1 && retorno.dem_venda__servico_grafico.data.length >= 1) {
          grafico.dem_venda_servico = retorno.dem_venda__servico_grafico.data
        }
        if (keys.indexOf('dem_dev_cliente_grafico') !== -1 && retorno.dem_dev_cliente_grafico.data.length >= 1) {
          grafico.dem_dev_cliente = retorno.dem_dev_cliente_grafico.data
        }

        // CHAMA A FUNÇÃO PARA MONTAR O GRAFICO
        if (Object.keys(grafico).length >= 1) {
          // RODA O FOR MONTANDO OS VALORES
          for (var indexD in grafico) {
            for (var indexL in grafico[indexD]) {
              // VERIFICA O TIPO DE REGISTRO
              var _tipo = indexD === 'dem_venda_servico' ? 'servico' : 'produto'

              // MANDA CALCULAR OS VALORES
              grafico[indexD][indexL] = CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(grafico[indexD][indexL], _tipo, {
                qtde:             'qtde_sum',
                valor_tot:        'valor_tot_sum',
                valor_fre:        'valor_fre_sum',
                valor_seg:        'valor_seg_sum',
                valor_des:        'valor_des_sum',
                valor_oda:        'valor_oda_sum',
                p_icms_st_v:      'p_icms_st_v_sum',
                p_icms_fcp_st_v:  'p_icms_fcp_st_v_sum',
                p_ipi_v:          'p_ipi_v_sum'
              })
            }
          }

          // CHAMA A FUNÇÃO PARA SETAR OS VALORES NO GRAFICO
          this.appHisMontarGraficoDados(grafico)
        }

        // SETA O VALOR RECEBIDO
        this.pesquisa = typeof this.pesquisa === 'object' ? Object.assign(this.pesquisa, pesquisa) : pesquisa

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appHisMontarColunaGrafico: function (data) {
        // INICIA A VARIAVEL
        var nome = ''
        var ini = ''
        var fim = ''

        // MONTA O NOME DA COLUNA NO GRAFICO
        if (this.params.qtdeMes <= 1) {
          // PEGA A DATA INICIAL DA COLUNA
          ini = moment(data, 'DD/MM/YYYY')

          // PEGA A DATA FINAL
          fim = moment(data, 'DD/MM/YYYY')

          // MONTA O NOME DA COLUNA
          nome = ini.format('DD/MM/YYYY')
        } else if (this.params.qtdeMes <= 4) {
          // PEGA A DATA INICIAL DA COLUNA
          ini = moment(data, 'DD/MM/YYYY').startOf('week')

          // VERIFICA A DATA INICIAL
          if (ini.diff(moment(this.params.dataIni, 'DD/MM/YYYY'), 'days', true) < 0) {
            ini = moment(this.params.dataIni, 'DD/MM/YYYY')
          }

          // PEGA A DATA FINAL
          fim = moment(data, 'DD/MM/YYYY').endOf('week')

          // VERIFICA A DATA INICIAL
          if (fim.diff(moment(this.params.dataFim, 'DD/MM/YYYY'), 'days', true) > 0) {
            fim = moment(this.params.dataFim, 'DD/MM/YYYY')
          }

          // MONTA O NOME DA COLUNA
          nome = ini.format('DD/MM/YYYY') + ' à ' + fim.format('DD/MM/YYYY')
        } else if (this.params.qtdeMes >= 30) {
          // PEGA A DATA INICIAL DA COLUNA
          ini = moment(data, 'DD/MM/YYYY')

          // VERIFICA A QUANTIDADE DE DATAS PARA O GRAFICO
          switch (ini.format('MM')) {
            case '01':
            case '02':
              // SETA A DATA INICIAL
              ini = moment('01/01/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '01/' + ini.format('YYYY') + ' à ' + '02/' + ini.format('YYYY')
              break

            case '03':
            case '04':
              // SETA A DATA INICIAL
              ini = moment('01/03/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '03/' + ini.format('YYYY') + ' à ' + '04/' + ini.format('YYYY')
              break

            case '05':
            case '06':
              // SETA A DATA INICIAL
              ini = moment('01/05/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '05/' + ini.format('YYYY') + ' à ' + '06/' + ini.format('YYYY')
              break

            case '07':
            case '08':
              // SETA A DATA INICIAL
              ini = moment('01/07/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '07/' + ini.format('YYYY') + ' à ' + '08/' + ini.format('YYYY')
              break

            case '09':
            case '10':
              // SETA A DATA INICIAL
              ini = moment('01/09/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '09/' + ini.format('YYYY') + ' à ' + '10/' + ini.format('YYYY')
              break

            case '11':
            case '12':
              // SETA A DATA INICIAL
              ini = moment('01/11/' + ini.format('YYYY'), 'DD/MM/YYYY')

              // MONTA O NOME DA COLUNA
              nome = '11/' + ini.format('YYYY') + ' à ' + '12/' + ini.format('YYYY')
              break
          }
        } else {
          // CARREGA A DATA
          ini = moment(data, 'DD/MM/YYYY').startOf('month')

          // MONTA O NOME DA COLUNA
          nome = ini.format('MM/YYYY')
        }
        
        // MONTA O TIME DA DATA INICIAL
        var time = ini.format('X').toString()

        // VERIFICA SE O PERIODO JÁ EXISTE
        if (time !== '' && this.params.colunas[time] === undefined) {
          // SETA O NOME DA COLUNA NO GRAFICO
          this.params.colunas[time] = nome
          
          // MONTA O VALOR INICIAL DO GRAFICO
          this.params.linhaB.push(0)
        }
        
        // RETORNA O VALOR
        return time
      },
      appHisReordenarVetor: function (vetor) {
        // PEGA AS COLUNAS PARA ORDENAR
        var _vetor = JSON.parse(JSON.stringify(vetor))

        // ORDENA O VETOR
        return Object.keys(_vetor).sort().reduce((vet, index) => {
          // SETA O VALOR PARA O NOVO VETOR
          vet[index] = vetor[index]

          // RETORNA O NOVO VETOR
          return vet
        }, {})
      },
      appHisMontarGraficoDados: function (grafico = null) {
        // INICIA AS VARIAVEIS
        var modo = null       
        var mapa = {}
        var data = ''
        this.params.valores = []

        // OCULTA O GRAFICO
        if ([ '', null, undefined ].indexOf(this.grafico) === -1) {
          this.grafico.destroy()
        }
        
        // VERIFICA SE TEM PARAMETROS
        if (grafico !== null) {
          // SETA O VALOR INICIAL
          this.params.linhaB = []
          this.params.colunas = {}

          // SETA O VALOR RECEBIDO
          this.params.grafico = JSON.parse(JSON.stringify(grafico))
  
          // RODA O VETOR ADICIONANDO OS VALORES
          for (var index in this.params.grafico) {
            for (var indexC in this.params.grafico[index]) {
              // // CONVERTE O VALOR EM NUMERO
              // this.params.grafico[index][indexC].qtde_sum = Number(this.params.grafico[index][indexC].qtde_sum)
              // this.params.grafico[index][indexC].valor_tot_sum = Number(Number(this.params.grafico[index][indexC].valor_tot_sum).toFixed(2))

              // PEGA A DATA QUE SERÁ CALCULADA
              data = this.params.grafico[index][indexC].vcto_day + '/' + this.params.grafico[index][indexC].vcto_month + '/' + this.params.grafico[index][indexC].vcto_year
              
              // VERIFICA SE ESSA DATA JÁ FOI PROCESSADA
              if (mapa[data] === undefined) {
                mapa[data] = this.appHisMontarColunaGrafico(data)
              }
            }
          }

          // VERIFICA O MODO DE COMPARAÇÃO
          if (this.params.qtdeMes <= 1) {
            modo = { diff: 'days', add: 'd' }
          } else if (this.params.qtdeMes <= 4) {
            modo = { diff: 'week', add: 'weeks' }
          } else {
            modo = { diff: 'months', add: 'M' }
          }
          
          // CALCULA A QUANTIDADE DE MESES
          var qtdeM = Math.ceil(moment(this.params.dataFim, 'DD/MM/YYYY').diff(moment(this.params.dataIni, 'DD/MM/YYYY'), modo.diff, true))
          
          // VERIFICA SE DEVE SOMAR UM NA QUANTIDADE
          if (this.params.qtdeMes <= 1) {
            qtdeM = qtdeM + 1
          }

          // RODA O FOR ADICIONANDO OS VALORES
          for (var i = 1; i <= qtdeM; i++) {
            // CARREGA A DATA QUE DEVE CUSAR
            data = moment(this.params.dataIni, 'DD/MM/YYYY')
            
            // PEGA DA DATA INICIAL E ADICONA O VALOR
            if (data >= 2) {
              data = data.add((i - 1).toString(), modo.add)
            }

            // PEGA A DATA QUE SERÁ CALCULADA
            data = data.format('DD/MM/YYYY')
              
            // VERIFICA SE ESSA DATA JÁ FOI PROCESSADA
            if (mapa[data] === undefined) {
              mapa[data] = this.appHisMontarColunaGrafico(data)
            }
          }
        }

        // PEGA AS COLUNAS PARA ORDENAR
        var colunas = JSON.parse(JSON.stringify(this.params.colunas))

        // ORDENA O VETOR
        this.params.colunas = Object.keys(colunas).sort().reduce((vet, index) => {
          // SETA O VALOR PARA O NOVO VETOR
          vet[index] = colunas[index]

          // RETORNA O NOVO VETOR
          return vet
        }, {})

        // LIMPA AS VARIAVEIS
        mapa = {}
        
        // PEGA OS INDEX DAS COLUNAS
        var indexsC = Object.keys(this.params.colunas)
        
        // VERIFICA OS DADOS RECEBIDOS
        for (var indexG in this.params.grafico) {
          // INICIA O VALOR DA CHAVE
          var item = { fill: false, tension: 0.1, data: JSON.parse(JSON.stringify(this.params.linhaB)), borderWidth: 2 }

          // VERIFICA O NOME DA DEMANDA
          switch (indexG) {
            case 'dem_venda_produto':
              item.label = 'Venda Produto'
              item.borderColor = 'rgba(8,165,59,0.6)'
              break
            case 'dem_venda_servico':
              item.label = 'Venda Servico'
              item.borderColor = 'rgba(117,10,255,0.6)'
              break

            case 'dem_compra':
              item.label = 'Compra'
              item.borderColor = 'rgba(141,67,160,0.6)'
              break

            case 'dem_dev_cliente':
              item.label = 'Dev. Cliente'
              item.borderColor = 'rgba(154,85,46,0.6)'
              break

            case 'dem_dev_fornecedor':
              item.label = 'Dev. Fornecedor'
              item.borderColor = 'rgba(210,107,24,0.6)'
              break

            case 'fabricacao':
              item.label = 'Fabricação - Produto Acabado'
              item.borderColor = 'rgba(70,27,60,0.6)'
              break

            case 'insumo':
              item.label = 'Fabricação - Insumo'
              item.borderColor = 'rgba(70,27,60,0.6)'
              break
          }
          
          // RODA O VETOR ADICIONANDO OS VALORES
          for (var indexDG in this.params.grafico[indexG]) {
            // this.appHisMontarColunaGrafico(this.params.grafico[indexG][indexDG].vcto_day + '/' + this.params.grafico[indexG][indexDG].vcto_month + '/' + this.params.grafico[indexG][indexDG].vcto_year)
            // // PEGA A DATA INICIAL DA COLUNA
            // ini = moment(this.params.grafico[indexG][indexDG].vcto_day + '/' + this.params.grafico[indexG][indexDG].vcto_month + '/' + this.params.grafico[indexG][indexDG].vcto_year, 'DD/MM/YYYY').startOf('week')

            // // VERIFICA A DATA INICIAL
            // if (ini.diff(moment(this.filtros.dat.dataIni, 'DD/MM/YYYY'), 'days', true) < 0) {
            //   ini = moment(this.filtros.dat.dataIni, 'DD/MM/YYYY')
            // }
            
            // // PEGA O TIME DO INI PARAR PROCURAR CHAVE
            // ini = ini.format('X').toString()

            // PEGA A DATA QUE SERÁ CALCULADA
            data = this.params.grafico[indexG][indexDG].vcto_day + '/' + this.params.grafico[indexG][indexDG].vcto_month + '/' + this.params.grafico[indexG][indexDG].vcto_year
            
            // VERIFICA SE ESSA DATA JÁ FOI PROCESSADA
            if (mapa[data] === undefined) {
              mapa[data] = indexsC.indexOf(this.appHisMontarColunaGrafico(data))
            }

            // PEGA O INDEX DO VETOR
            index = mapa[data]
            
            // SETA O VALOR DA COLUNA
            if (this.params.tipo === 'qtde') {
              item.data[index] += Number(this.params.grafico[indexG][indexDG].qtde_sum)
              item.data[index] = Number(item.data[index].toFixed(4))
            } else {
              item.data[index] += this.params.grafico[indexG][indexDG].total
              item.data[index] = Number(item.data[index].toFixed(2))
            }
          }

          // ADICIONA O VALOR NO GRAFICO
          this.params.valores.push(item)
        }

        // MOSTRA O GRAFICO
        this.grafico = ''

        // CHAMA A FUNÇÃO PRA MONTAR O GRAFICO NA TELA
        this.appHisMontarGraficoTela(this.params.colunas, this.params.valores)
      },
      appHisMontarGraficoTela: function (colunas, valores, tentativa = 0) {
        if (tentativa <= 10 && this.$refs.grafico === undefined) {
          setTimeout(() => { this.appHisMontarGraficoTela(colunas, valores, (tentativa + 1)) }, 500)
        } else if (this.$refs.grafico !== undefined) {
          // IMPORTA A FUNÇÃO
          const Chart = require('chart.js')
  
          // SETA O GRAFICO NA TELA
          this.grafico = new Chart(this.$refs.grafico, {
            type: (this.params.linhaB.length <= 1 ? 'bar' : 'line'),
            data: {
              labels: Object.values(colunas),
              datasets: valores
            },
            options: {
              scales: {
                xAxes: [
                  {
                    ticks: {
                      autoSkip: false,
                      maxRotation: 45,
                      minRotation: 45,
                    },
                    scaleLabel: {
                      display: true,
                      labelString: 'Linha do tempo'
                    }
                  }
                ],
                yAxes: [ 
                  {
                    scaleLabel: {
                      display: true,
                      labelString: (this.params.tipo === 'qtde' ? 'Quantidade' : 'Valor R$')
                    },
                    ticks: {
                      callback: (label) => {
                        switch (this.params.tipo) {
                          case 'qtde':
                            return this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', label.toString())

                          case 'valor':
                            return this.$store.state.FUN_MASK_VALOR('valorMoeda', (label * 100).toFixed(0).toString())
                        }
                      }
                    }
                  }
                ]
              },
              tooltips: {
                enabled: true,
                mode: 'single',
                callbacks: {
                  label: (item) => {
                    // INICIA A VARIAVEL
                    var retorno = (this.params.tipo === 'qtde' ? 'Quantidade' : 'Valor') + ' ' + this.params.valores[item.datasetIndex].label + ': '
                    
                    // VERIFICA O TIPO DE DADOS QUE ESTÁ TRABALHANDO
                    switch (this.params.tipo) {
                      case 'qtde':
                        retorno += this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', item.value)
                        break

                      case 'valor':
                        retorno += 'R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', (item.value * 100).toFixed(0).toString())
                        break
                    }

                    // RETORNA O VALOR MONTADO
                    return retorno
                  }
                }
              }
            }
          })
        }
      },
      appHisPesquisar: function () {
        // SETA O STATUS DE CARREGANDO
        this.pesquisa = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE AGUARDAR CARREGAMENTO
        if (this.filtros.dat !== '' && (typeof this.filtros.dat === 'string' || this.filtros.dat._dataIni === undefined)) {
          // return 
          setTimeout(() => { this.appHisPesquisar() }, 50)
        } else {
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // CARREGA AS DEMANDAS SELECIONADAS
          this.appHisBuscarDemandas((demandas) => {
            // INICIA AS VARIAVEIS
            var querys = {}

            // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
            this.tabper = this.$store.state.mPer[this.mper.tabper]
      
            // VERIFICA SE TEM ALGUMA PERSONALIZAÇÃO
            if (this.tabper.flag !== false) {
              // SETA AS COLUNAS MARCADAS
              for (var indexC in this.mper.fieldOptions) {
                // OCULTA TODAS AS COLUNAS OPCIONAIS
                if (this.mper.fieldOptions[indexC].mPer === 1) {
                  this.mper.fieldOptions[indexC].mPer = 0
                }
      
                // VERIFICA SE A COLUNA DEVE SER APRESENTADA
                if (this.mper.fieldOptions[indexC].mPer === 0 && this.tabper.field.indexOf(this.mper.fieldOptions[indexC].chave) !== -1) {
                  this.mper.fieldOptions[indexC].mPer = 1
                }
              }
            }
  
            // INICIA A VARIAVEL
            var pesquisa = []
  
            // RODA O VETOR
            for (var indexD in demandas) {
              if (this.filtros.dem === '' || this.filtros.dem.indexOf(demandas[indexD].id) !== -1) {
                pesquisa.push(demandas[indexD].id)
              }
            }
  
            // ADICIONA A BUSCA DO PRODUTO
            if (this.filtros.pro !== '__NENHUM__' && this.permissoes.pro === true && (this.filtros.dem === '' || this.filtros.dem.indexOf('dem_venda') !== -1)) {
              pesquisa.push('dem_venda__produto')
            }
  
            // ADICIONA A BUSCA DO PRODUTO
            if (this.filtros.ser !== '__NENHUM__' && this.permissoes.ser === true && (this.filtros.dem === '' || this.filtros.dem.indexOf('dem_venda') !== -1)) {
              pesquisa.push('dem_venda__servico')
            }
  
            // REMOVE O DEM_VENDA DA PESQUISA
            pesquisa = pesquisa.filter(item => item !== 'dem_venda')
  
            // INICIA A VARIAVEL
            var chave = ''
            
            // INICIA O AGRUPAMENTO GRAFICO
            this.params.qtdeMes = null
            this.params.tipo = this.campos.tp_grafico.value === true ? 'valor' : 'qtde'
            
            // MONTA A DATA INICIAL E FINAL DA PESQUISA
            if (this.filtros.dat !== '') {
              this.appHisMontarDataIniDataFimPesquisa(this.filtros.dat.dataIni, this.filtros.dat.dataFim)
            }
  
            // MONTA TODOS OS REQUESTS PARA API
            for (var indexP in pesquisa) {
              // ADICIONA A PESQUISA MONTADA AO VETOR
              chave = pesquisa[indexP]
              querys[chave] = this.appHisMontarPesquisa(chave)
  
              // ADICIONA A PESQUISA MONTADA AO VETOR
              chave = pesquisa[indexP] + '_qtde'
              querys[chave] = this.appHisMontarPesquisa(chave)
  
              // ADICIONA A PESQUISA MONTADA AO VETOR
              chave = pesquisa[indexP] + '_grafico'
              querys[chave] = this.appHisMontarPesquisa(chave)
              
              // VERIFICA SE TEM DATA NO RELATORIO
              if (this.params.qtdeMes === null) {
                chave = pesquisa[indexP] + '_data_ini_fim'
                querys[chave] = this.appHisMontarPesquisa(chave)
              }
            }
    
            // FAZ A BUSCA DOS DADOS NA API
            this.$store.state.comunicaAPI('/rota-multipla', 'POST', querys, (retorno) => {
              // VERIFICA SE DEU ALGUM ERRO
              var erro = false

              // JUNTA OS VALORES RECEBIDOS
              if (erro === false) {
                for (var index in retorno) {
                  if (retorno[index].code !== '200') {
                    // APRESENTA A MENSAGEM DE SUCESSO
                    this.$store.state.TRATAR_RET_LOT_API(retorno[index])

                    // SETA O STATUS NA TELA
                    this.appHisSetarStatusGeral(retorno[index])

                    // SETA O FLAG QUE FOI IDENTIFICADO UM ERRO
                    erro = true

                    // PARA DE RODAR O VETOR
                    break
                  }
                }
              }

              // VERIFICA SE DEU ALGUM ERRO NO REQUEST
              if (erro === false) {
                // VERIFICA SE DEVE CALCULAR A QUANTIDADE DE MESES
                if (this.params.qtdeMes === null) {
                  // INICIA A VARIAVEL
                  var datas = {}
                  var item = null
  
                  // FAZ A VERIFICAÇÃO DOS VALORES
                  for (var indexR in retorno) {
                    if (indexR.indexOf('_data_ini_fim') !== -1) {
                      // VERIFICA SE TEM VALOR RECEBIDO
                      item = retorno[indexR].data.length >= 1 ? retorno[indexR].data[0] : null
  
                      // VERIFICA SE TEM VALOR RECEBIDO
                      if (item !== null) {                      
                        // CONVERTE O VALOR RECEBIDO
                        item.time_min = moment(item.vcto_min, 'DD/MM/YYYY').format('X').toString()
  
                        // CONVERTE O VALOR RECEBIDO
                        item.time_max = moment(item.vcto_max, 'DD/MM/YYYY').format('X').toString()
                        
                        // SETA OS VALORES MONTADOS
                        datas[item.time_min] = item.vcto_min
                        datas[item.time_max] = item.vcto_max
                      }
                    }
                  }
  
                  // ORDENA O VETOR RECEBIDO
                  datas = this.appHisReordenarVetor(datas)
  
                  // PEGA AS CHAVE DAS DATAS
                  item = Object.keys(datas)
  
                  // MONTA A DATA INICIAL E FINAL DA PESQUISA
                  this.appHisMontarDataIniDataFimPesquisa(datas[item[0]], datas[item[(item.length - 1)]])
                }

                // CHAMA A FUNÇÃO PARA SETAR
                this.appHisSetarTotais(retorno)
              }
            }, this.appHisSetarStatusGeral)
          })
        }
      },
      appHisMontarDataIniDataFimPesquisa: function (dataIni, dataFim) {
        // VERIFICA SE TEM DATA INICIAL E NÃO TEM DATA FINAL
        if ([ '', null, undefined, NaN ].indexOf(dataIni) === -1 && [ '', null, undefined, NaN ].indexOf(dataFim) !== -1) {
          dataFim = dataIni
        }

        // CALCULA A DIFERENÇA DE MESES
        this.params.qtdeMes = Math.ceil(moment(dataFim, 'DD/MM/YYYY').diff(moment(dataIni, 'DD/MM/YYYY'), 'months', true))

        // SETA A DATA INICIAL
        this.params.dataIni = dataIni

        // SETA A DATA INICIAL
        this.params.dataFim = dataFim
      },
      appHisMontarPesquisa: function (chave) {
        // INICIA A VARIAVEL
        var pesquisa = { rota: this.appHisMontarRouter(chave), metodo: this.appHisMontarMethod(chave) }

        // VERIFICA A DEMANDA QUE DEVE MONTAR
        switch (chave) {
          // case 'insumo':
          //   // INICIA O QUERYGET
          //   pesquisa.parametro = { type: 'list', limit: { row: 0, qty: this.tabper.rpp } }
            
          //   // MONTA O WHERE QUE SERÁ REALIZADO
          //   pesquisa.parametro.field = this.appHisMontarField(chave)

          //   // MONTA O WHERE QUE SERÁ REALIZADO
          //   pesquisa.parametro.where = this.appHisMontarWhere(chave)
          //   break

          case 'fabricacao_data_ini_fim':
          case 'insumo_data_ini_fim':
          case 'dem_compra_data_ini_fim':
          case 'dem_dev_fornecedor_data_ini_fim':
          case 'dem_venda__produto_data_ini_fim':
          case 'dem_venda__servico_data_ini_fim':
          case 'dem_dev_cliente_data_ini_fim':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: 0, qty: 1 } }
            
            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.field = this.appHisMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.appHisMontarWhere(chave)
            break

          case 'fabricacao':
          case 'insumo':
          case 'dem_compra':
          case 'dem_dev_fornecedor':
          case 'dem_venda__produto':
          case 'dem_venda__servico':
          case 'dem_dev_cliente':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: 0, qty: this.tabper.rpp } }
            
            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.field = this.appHisMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.appHisMontarWhere(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.order = this.appHisMontarOrder(chave)
            break

          case 'fabricacao_qtde':
          case 'insumo_qtde':
          case 'dem_compra_qtde':
          case 'dem_dev_fornecedor_qtde':
          case 'dem_venda__produto_qtde':
          case 'dem_venda__servico_qtde':
          case 'dem_dev_cliente_qtde':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: 0, qty: this.tabper.rpp } }
            
            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.field = this.appHisMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.appHisMontarWhere(chave)

            // SETA A CHAVE GROUP
            pesquisa.parametro.group = [ 'status' ]
            break

          case 'fabricacao_grafico':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: 0, qty: 1000 } }

            // SETA OS CAMPOS
            pesquisa.parametro.field = this.appHisMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.appHisMontarWhere(chave)

            // SETA A CHAVE GROUP
            pesquisa.parametro.group = [ { f: 'last_at', o: 'year' }, { f: 'last_at', o: 'month' } ]
            break

          case 'insumo_grafico':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: 0, qty: 1000 } }

            // SETA OS CAMPOS
            pesquisa.parametro.field = this.appHisMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.appHisMontarWhere(chave)

            // SETA A CHAVE GROUP
            pesquisa.parametro.group = [ { f: 'last_at', o: 'year' }, { f: 'last_at', o: 'month' } ]
            break

          case 'dem_compra_grafico':
          case 'dem_dev_fornecedor_grafico':
          case 'dem_dev_cliente_grafico':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: 0, qty: 1000 } }

            // SETA OS CAMPOS
            pesquisa.parametro.field = this.appHisMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.appHisMontarWhere(chave)

            // SETA A CHAVE GROUP
            pesquisa.parametro.group = [ { m: 'demanda', f: 'vencimento', o: 'year' }, { m: 'demanda', f: 'vencimento', o: 'month' } ]
            break

          case 'dem_venda__produto_grafico':
          case 'dem_venda__servico_grafico':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: 0, qty: 1000 } }

            // SETA OS CAMPOS
            pesquisa.parametro.field = this.appHisMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.appHisMontarWhere(chave)

            // // SETA O ORDER QUE DEVE REALIZAR
            // pesquisa.parametro.order = { vcto: 'asc' }

            // SETA A CHAVE GROUP
            if (this.params.qtdeMes <= 1) {
              pesquisa.parametro.group = [ { m: 'venda', f: 'vencimento', o: 'year' }, { m: 'venda', f: 'vencimento', o: 'month' }, { m: 'venda', f: 'vencimento', o: 'day' } ]
            } else if (this.params.qtdeMes <= 4) {
              pesquisa.parametro.group = [ { m: 'venda', f: 'vencimento', o: 'year' }, { m: 'venda', f: 'vencimento', o: 'month' } ]
            } else {
              pesquisa.parametro.group = [ { m: 'venda', f: 'vencimento', o: 'year' }, { m: 'venda', f: 'vencimento', o: 'week' } ]
            }
            break
        }

        // RETORNA O VALOR MONTADO
        return JSON.parse(JSON.stringify(pesquisa))
      },
      // appHisPesquisar: function (demandas = [], querys = {}) {
      //   // SETA O STATUS DE CARREGANDO
      //   this.pesquisa = 'carregando'

      //   // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //   this.time = new Date().getTime()

      //   // INICIA A VARIAVEL
      //   var pesquisa = {}

      //   // FAZ A BUSCA DOS VALORES
      //   if (demandas.length === 0 && Object.keys(querys).length === 0) {
      //     this.appHisBuscarDemandas((demandas) => {
      //       // INICIA A VARIAVEL
      //       pesquisa = []
  
      //       // RODA O VETOR
      //       for (var index in demandas) {
      //         if (this.filtros.dem === '' || this.filtros.dem.indexOf(demandas[index].id) !== -1) {
      //           pesquisa.push(demandas[index].id)
      //         }
      //       }

      //       // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
      //       this.tabper = this.$store.state.mPer[this.mper.tabper]
      
      //       // VERIFICA SE TEM ALGUMA PERSONALIZAÇÃO
      //       if (this.tabper.flag !== false) {
      //         // SETA AS COLUNAS MARCADAS
      //         for (var indexC in this.mper.fieldOptions) {
      //           // OCULTA TODAS AS COLUNAS OPCIONAIS
      //           if (this.mper.fieldOptions[indexC].mPer === 1) {
      //             this.mper.fieldOptions[indexC].mPer = 0
      //           }
      
      //           // VERIFICA SE A COLUNA DEVE SER APRESENTADA
      //           if (this.mper.fieldOptions[indexC].mPer === 0 && this.tabper.field.indexOf(this.mper.fieldOptions[indexC].chave) !== -1) {
      //             this.mper.fieldOptions[indexC].mPer = 1
      //           }
      //         }
      //       }

      //       // REINICIA O PROCESSO
      //       this.appHisPesquisar(pesquisa, querys)
      //     })
      //   } else if (demandas.length === 0 && Object.keys(querys).length >= 0) {
      //     this.$store.state.comunicaAPI('/rota-multipla', 'POST', querys, (retorno) => {
      //       this.appHisSetarTotais(retorno)
      //     }, this.appHisSetarStatusGeral)
      //   } else if (demandas[0] === 'dem_venda') {
      //     // EXCLUIR O VALOR E ADICIONA OUTROS 2
      //     demandas.splice(0, 1)

      //     // ADICIONA A BUSCA DO PRODUTO
      //     if (this.permissoes.pro === true && (this.filtros.dem === '' || this.filtros.dem.indexOf('dem_venda') !== -1)) {
      //       demandas.push('dem_venda__produto')
      //     }

      //     // ADICIONA A BUSCA DO PRODUTO
      //     if (this.permissoes.ser === true && (this.filtros.dem === '' || this.filtros.dem.indexOf('dem_venda') !== -1)) {
      //       demandas.push('dem_venda__servico')
      //     }

      //     // REINICIA O PROCESSO
      //     this.appHisPesquisar(demandas, querys)
      //   } else {
      //     // INICIA OS VALORES DA PESQUISA
      //     pesquisa = { rota: this.appHisMontarRouter(demandas[0]), metodo: this.appHisMontarMethod(demandas[0]) }

      //     // INICIA O QUERYGET
      //     pesquisa.parametro = { type: 'list', limit: { row: 0, qty: this.tabper.rpp } }

      //     // MONTA O WHERE QUE SERÁ REALIZADO
      //     pesquisa.parametro.field = this.appHisMontarField(demandas[0])

      //     // MONTA O WHERE QUE SERÁ REALIZADO
      //     pesquisa.parametro.where = this.appHisMontarWhere(demandas[0])

      //     // MONTA O WHERE QUE SERÁ REALIZADO
      //     pesquisa.parametro.order = this.appHisMontarOrder(demandas[0])

      //     // CONVERTE A PESQUISA RECEBIDA
      //     pesquisa.parametro = JSON.stringify(pesquisa.parametro)

      //     // ADICIONA A PESQUISA MONTADA AO VETOR
      //     querys[demandas[0]] = JSON.parse(JSON.stringify(pesquisa))

      //     // PEGA A PESQUISA RECEBIDA
      //     pesquisa.parametro = JSON.parse(pesquisa.parametro)

      //     // SETA O FIELD DOS CAMPOS
      //     pesquisa.parametro.field = this.appHisMontarField(demandas[0] + '_qtde')

      //     // REMOVE A CHAVE ORDER DA CONSULTA QTDE
      //     delete pesquisa.parametro.order

      //     // SETA A CHAVE GROUP
      //     pesquisa.parametro.group = [ 'status' ]

      //     // CONVERTE A PESQUISA RECEBIDA
      //     pesquisa.parametro = JSON.stringify(pesquisa.parametro)

      //     // ADICIONA A PESQUISA MONTADA AO VETOR
      //     querys[demandas[0] + '_qtde'] = JSON.parse(JSON.stringify(pesquisa))

      //     // EXCLUIR O VALOR E ADICIONA OUTROS 2
      //     demandas.splice(0, 1)

      //     // REINICIA O PROCESSO
      //     this.appHisPesquisar(demandas, querys)
      //   }
      // },
      appHisMontarClassDemanda: function (demanda) {
        switch (demanda) {
          case 'dem_venda':
            return 'background-tp-4'

          case 'dem_compra':
            return 'background-tp-3'

          case 'dem_dev_fornecedor':
            return 'background-tp-5'

          case 'dem_dev_cliente':
            return 'background-tp-5'
        }
      },
      appHisAlterarGrafico: function (value) {
        // SETA O VALOR RECEBIDO
        this.campos.tp_grafico.value = value

        // SETA O TIPO DO GRAFICO QUE DEVE SER CARREGADO
        this.params.tipo = this.campos.tp_grafico.value === true ? 'valor' : 'qtde'
        
        // CHAMA A FUNÇÃO PARA MONTAR O GRAFICO NA TELA
        this.appHisMontarGraficoDados()
      },
      appHisOnChangeAba: function (aba) {
        // SETA A ABA SELECIONADA
        this.abaVal = aba

        // SETA O STATUS DE CARREGAMENTO DA TELA
        this.pesquisa[aba].carregado = false

        // SETA O STATUS DE CARREGAMENTO DA TELA
        this.pesquisa[aba].mostrar = false

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    computed: {
      appHisContarColunasLinha1: function () {
        // INICIA A CONTA DE COLUNAS
        var qtde = 1

        // VERIFICA SE TEM O PACOTE VEICULO
        qtde = (qtde + ((this.permissoes.vei === true && (this.filtros.dem === '' || this.filtros.dem.indexOf('dem_venda') !== -1)) ? 1 : 0))

        // VERIFICA SE TEM O PACOTE PET
        qtde = (qtde + ((this.permissoes.pet === true && (this.filtros.dem === '' || this.filtros.dem.indexOf('dem_venda') !== -1)) ? 1 : 0))

        // RETORNA O VALOR
        return qtde
      },
      appHisMontarColunas: function () {
        // INICIA A VARIAVEL
        var fields = [] 

        // VERIFICA O TIPO DA DEMANDA
        switch (this.abaVal) {
          case 'fabricacao':
            fields = [
              { mPer: 2,  chave: 'demandaId',               nome: 'Demanda Cód.'          },
              { mPer: 2,  chave: 'item_codigo',             nome: 'Cód.'                  },
              { mPer: 2,  chave: 'item_nome',               nome: 'Nome'                  },
              { mPer: 2,  chave: '_qtde',                   nome: 'Qtde.'                 },
              { mPer: 2,  chave: 'last',                    nome: 'Data Fabricação',      }
              // { mPer: 2,  chave: 'last',                    nome: 'Última Alteração',     }
            ]
            break

          case 'insumo':
            fields = [
              { mPer: 2,  chave: 'demandaId',               nome: 'Demanda Cód.'          },
              { mPer: 2,  chave: 'item_codigo',             nome: 'Cód.'                  },
              { mPer: 2,  chave: 'item_nome',               nome: 'Nome'                  },
              { mPer: 2,  chave: '_qtde',                   nome: 'Qtde.'                 },
              { mPer: 2,  chave: 'last',                    nome: 'Data Utilização',      }
              // { mPer: 2,  chave: 'last',                    nome: 'Última Alteração',     }
            ]
            break

          default:
            fields = [
              { mPer: 1,  chave: 'demandaId',               nome: 'Demanda Cód.'          },
              { mPer: 1,  chave: 'demandaId_id_con_nome',   nome: 'Contato'               },
              { mPer: 1,  chave: 'demandaId_data',          nome: 'Demanda Data'          },
              { mPer: 1,  chave: 'item_codigo',             nome: 'Cód.'                  },
              { mPer: 1,  chave: 'item_nome',               nome: 'Nome'                  },
              { mPer: 1,  chave: '_qtde',                   nome: 'Qtde.'                 },
              { mPer: 1,  chave: '_valor_uni',              nome: 'Valor Unitário'        },
              { mPer: 0,  chave: '_valor_tot',              nome: 'Subtotal'              },
              { mPer: 0,  chave: '_valor_fre',              nome: 'Valor Frete'           },
              { mPer: 0,  chave: '_valor_seg',              nome: 'Valor Seguro'          },
              { mPer: 0,  chave: '_valor_des',              nome: 'Valor Desconto'        },
              { mPer: 0,  chave: '_valor_oda',              nome: 'Valor ODA'             },
              { mPer: 0,  chave: '_p_ipi_v',                nome: 'Valor IPI'             },
              { mPer: 0,  chave: '_p_icms_st_v',            nome: 'Valor ICMS ST'         },
              { mPer: 0,  chave: '_p_icms_fcp_st_v',        nome: 'Valor ICMS FCP ST'     },
              { mPer: 1,  chave: '_total',                  nome: 'Total', explica: { mensagem: 'Total  = ((Qtde * Valor Unitário) + Valor Frete + Valor Seguro + Valor Desconto + Valor ODA + Valor IPI + Valor ICMS ST + Valor ICMS FCP ST)', posicaoMy: 'top right', posicaoAt: 'bottom left' } }
            ]
            break
        }

        // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
        var tabper = this.$store.state.mPer[this.mper.tabper]
      
        // VERIFICA SE TEM ALGUMA PERSONALIZAÇÃO
        if (tabper.flag !== false) {
          // SETA AS COLUNAS MARCADAS
          for (var indexC in fields) {
            // OCULTA TODAS AS COLUNAS OPCIONAIS
            if (fields[indexC].mPer === 1) {
              fields[indexC].mPer = 0
            }

            // VERIFICA SE A COLUNA DEVE SER APRESENTADA
            if (fields[indexC].mPer === 0 && tabper.field.indexOf(fields[indexC].chave) !== -1) {
              fields[indexC].mPer = 1
            }
          }
        }

        // RETORNA O VALOR MONTADO
        return fields
      }
    },
    watch: {
      '$route': function (routeAtual, routeAnterior) {
        if (routeAnterior.name !== routeAtual.name) {
          // SETA O STATUS DA PAGINA
          this.appHisSetarStatusGeral('carregando')

          // LIMPA AS VARIAVEIS
          this.tabper = {}
          this.mper.tabper = ''

          // FAZ A VERIFICAÇÃO DAS PERMISSÕES DO USUARIO
          this.appHisVerificarPermissao()

          // MANDA ATUALIZAR A TABELA
          setTimeout(() => { this.appHisIniciar() }, 500)
        }
      }
    }
  }
</script>
